var map = {
	"./brands/accessible-icon.svg": [
		5879,
		5879
	],
	"./brands/accusoft.svg": [
		16592,
		16592
	],
	"./brands/acquisitions-incorporated.svg": [
		76730,
		76730
	],
	"./brands/adn.svg": [
		43322,
		43322
	],
	"./brands/adobe.svg": [
		97832,
		97832
	],
	"./brands/adversal.svg": [
		74879,
		74879
	],
	"./brands/affiliatetheme.svg": [
		24227,
		24227
	],
	"./brands/airbnb.svg": [
		7118,
		7118
	],
	"./brands/algolia.svg": [
		51545,
		51545
	],
	"./brands/alipay.svg": [
		47537,
		47537
	],
	"./brands/amazon-pay.svg": [
		34885,
		34885
	],
	"./brands/amazon.svg": [
		88502,
		88502
	],
	"./brands/amilia.svg": [
		65880,
		65880
	],
	"./brands/android.svg": [
		20394,
		20394
	],
	"./brands/angellist.svg": [
		24043,
		24043
	],
	"./brands/angrycreative.svg": [
		21964,
		21964
	],
	"./brands/angular.svg": [
		51454,
		51454
	],
	"./brands/app-store-ios.svg": [
		10269,
		10269
	],
	"./brands/app-store.svg": [
		33051,
		33051
	],
	"./brands/apper.svg": [
		96701,
		96701
	],
	"./brands/apple-pay.svg": [
		66886,
		66886
	],
	"./brands/apple.svg": [
		60697,
		60697
	],
	"./brands/artstation.svg": [
		12298,
		12298
	],
	"./brands/asymmetrik.svg": [
		20054,
		20054
	],
	"./brands/atlassian.svg": [
		5352,
		5352
	],
	"./brands/audible.svg": [
		17392,
		17392
	],
	"./brands/autoprefixer.svg": [
		33607,
		33607
	],
	"./brands/avianex.svg": [
		71414,
		71414
	],
	"./brands/aviato.svg": [
		29057,
		29057
	],
	"./brands/aws.svg": [
		39758,
		39758
	],
	"./brands/bandcamp.svg": [
		11130,
		11130
	],
	"./brands/battle-net.svg": [
		8563,
		8563
	],
	"./brands/behance-square.svg": [
		88627,
		88627
	],
	"./brands/behance.svg": [
		95768,
		95768
	],
	"./brands/bimobject.svg": [
		83821,
		83821
	],
	"./brands/bitbucket.svg": [
		22627,
		22627
	],
	"./brands/bitcoin.svg": [
		47564,
		47564
	],
	"./brands/bity.svg": [
		32129,
		32129
	],
	"./brands/black-tie.svg": [
		16702,
		16702
	],
	"./brands/blackberry.svg": [
		98775,
		98775
	],
	"./brands/blogger-b.svg": [
		37719,
		37719
	],
	"./brands/blogger.svg": [
		5689,
		5689
	],
	"./brands/bluetooth-b.svg": [
		60170,
		60170
	],
	"./brands/bluetooth.svg": [
		16663,
		16663
	],
	"./brands/bootstrap.svg": [
		58230,
		58230
	],
	"./brands/btc.svg": [
		78549,
		78549
	],
	"./brands/buffer.svg": [
		99046,
		99046
	],
	"./brands/buromobelexperte.svg": [
		73103,
		73103
	],
	"./brands/buy-n-large.svg": [
		77044,
		76052
	],
	"./brands/buysellads.svg": [
		74448,
		74448
	],
	"./brands/canadian-maple-leaf.svg": [
		55274,
		55274
	],
	"./brands/cc-amazon-pay.svg": [
		67040,
		67040
	],
	"./brands/cc-amex.svg": [
		39673,
		39673
	],
	"./brands/cc-apple-pay.svg": [
		3226,
		3226
	],
	"./brands/cc-diners-club.svg": [
		70150,
		70150
	],
	"./brands/cc-discover.svg": [
		81721,
		81721
	],
	"./brands/cc-jcb.svg": [
		19240,
		19240
	],
	"./brands/cc-mastercard.svg": [
		79923,
		79923
	],
	"./brands/cc-paypal.svg": [
		870,
		870
	],
	"./brands/cc-stripe.svg": [
		17105,
		17105
	],
	"./brands/cc-visa.svg": [
		40558,
		40558
	],
	"./brands/centercode.svg": [
		6715,
		6715
	],
	"./brands/centos.svg": [
		98496,
		98496
	],
	"./brands/chrome.svg": [
		5166,
		5166
	],
	"./brands/chromecast.svg": [
		71874,
		71874
	],
	"./brands/cloudscale.svg": [
		64136,
		64136
	],
	"./brands/cloudsmith.svg": [
		99301,
		99301
	],
	"./brands/cloudversify.svg": [
		11025,
		11025
	],
	"./brands/codepen.svg": [
		44446,
		44446
	],
	"./brands/codiepie.svg": [
		65021,
		65021
	],
	"./brands/confluence.svg": [
		59627,
		59627
	],
	"./brands/connectdevelop.svg": [
		66355,
		66355
	],
	"./brands/contao.svg": [
		83934,
		83934
	],
	"./brands/cotton-bureau.svg": [
		41617,
		41617
	],
	"./brands/cpanel.svg": [
		28989,
		28989
	],
	"./brands/creative-commons-by.svg": [
		26001,
		26001
	],
	"./brands/creative-commons-nc-eu.svg": [
		37824,
		37824
	],
	"./brands/creative-commons-nc-jp.svg": [
		59183,
		59183
	],
	"./brands/creative-commons-nc.svg": [
		97601,
		97601
	],
	"./brands/creative-commons-nd.svg": [
		27432,
		27432
	],
	"./brands/creative-commons-pd-alt.svg": [
		93371,
		93371
	],
	"./brands/creative-commons-pd.svg": [
		39604,
		39604
	],
	"./brands/creative-commons-remix.svg": [
		6002,
		6002
	],
	"./brands/creative-commons-sa.svg": [
		18343,
		18343
	],
	"./brands/creative-commons-sampling-plus.svg": [
		79411,
		79411
	],
	"./brands/creative-commons-sampling.svg": [
		61175,
		61175
	],
	"./brands/creative-commons-share.svg": [
		53539,
		53539
	],
	"./brands/creative-commons-zero.svg": [
		67279,
		67279
	],
	"./brands/creative-commons.svg": [
		94158,
		94158
	],
	"./brands/critical-role.svg": [
		34778,
		34778
	],
	"./brands/css3-alt.svg": [
		30570,
		30570
	],
	"./brands/css3.svg": [
		5385,
		5385
	],
	"./brands/cuttlefish.svg": [
		32620,
		32620
	],
	"./brands/d-and-d-beyond.svg": [
		44518,
		44518
	],
	"./brands/d-and-d.svg": [
		2307,
		2307
	],
	"./brands/dailymotion.svg": [
		79922,
		79922
	],
	"./brands/dashcube.svg": [
		24965,
		24965
	],
	"./brands/delicious.svg": [
		7051,
		7051
	],
	"./brands/deploydog.svg": [
		40934,
		40934
	],
	"./brands/deskpro.svg": [
		46819,
		46819
	],
	"./brands/dev.svg": [
		18930,
		18930
	],
	"./brands/deviantart.svg": [
		88510,
		88510
	],
	"./brands/dhl.svg": [
		11634,
		11634
	],
	"./brands/diaspora.svg": [
		660,
		660
	],
	"./brands/digg.svg": [
		7605,
		7605
	],
	"./brands/digital-ocean.svg": [
		5126,
		5126
	],
	"./brands/discord.svg": [
		62709,
		62709
	],
	"./brands/discourse.svg": [
		61274,
		61274
	],
	"./brands/dochub.svg": [
		34803,
		34803
	],
	"./brands/docker.svg": [
		53499,
		53499
	],
	"./brands/draft2digital.svg": [
		47072,
		47072
	],
	"./brands/dribbble-square.svg": [
		30399,
		30399
	],
	"./brands/dribbble.svg": [
		94314,
		94314
	],
	"./brands/dropbox.svg": [
		93166,
		93166
	],
	"./brands/drupal.svg": [
		73256,
		73256
	],
	"./brands/dyalog.svg": [
		89133,
		89133
	],
	"./brands/earlybirds.svg": [
		23511,
		23511
	],
	"./brands/ebay.svg": [
		63037,
		63037
	],
	"./brands/edge.svg": [
		44466,
		44466
	],
	"./brands/elementor.svg": [
		45880,
		45880
	],
	"./brands/ello.svg": [
		77970,
		77970
	],
	"./brands/ember.svg": [
		38190,
		38190
	],
	"./brands/empire.svg": [
		9104,
		9104
	],
	"./brands/envira.svg": [
		73671,
		73671
	],
	"./brands/erlang.svg": [
		7653,
		7653
	],
	"./brands/ethereum.svg": [
		28843,
		28843
	],
	"./brands/etsy.svg": [
		37949,
		37949
	],
	"./brands/evernote.svg": [
		66074,
		66074
	],
	"./brands/expeditedssl.svg": [
		31444,
		31444
	],
	"./brands/facebook-f.svg": [
		72383,
		72383
	],
	"./brands/facebook-messenger.svg": [
		44407,
		44407
	],
	"./brands/facebook-square.svg": [
		31093,
		31093
	],
	"./brands/facebook.svg": [
		16447,
		16447
	],
	"./brands/fantasy-flight-games.svg": [
		39649,
		39649
	],
	"./brands/fedex.svg": [
		99085,
		99085
	],
	"./brands/fedora.svg": [
		60718,
		60718
	],
	"./brands/figma.svg": [
		99668,
		99668
	],
	"./brands/firefox-browser.svg": [
		31600,
		31600
	],
	"./brands/firefox.svg": [
		94336,
		94336
	],
	"./brands/first-order-alt.svg": [
		12696,
		12696
	],
	"./brands/first-order.svg": [
		52698,
		52698
	],
	"./brands/firstdraft.svg": [
		38970,
		38970
	],
	"./brands/flickr.svg": [
		62565,
		62565
	],
	"./brands/flipboard.svg": [
		25626,
		25626
	],
	"./brands/fly.svg": [
		42113,
		42113
	],
	"./brands/font-awesome-alt.svg": [
		37809,
		37809
	],
	"./brands/font-awesome-flag.svg": [
		80722,
		80722
	],
	"./brands/font-awesome-logo-full.svg": [
		21486,
		21486
	],
	"./brands/font-awesome.svg": [
		903,
		903
	],
	"./brands/fonticons-fi.svg": [
		51535,
		51535
	],
	"./brands/fonticons.svg": [
		33537,
		33537
	],
	"./brands/fort-awesome-alt.svg": [
		76095,
		76095
	],
	"./brands/fort-awesome.svg": [
		72444,
		72444
	],
	"./brands/forumbee.svg": [
		80361,
		80361
	],
	"./brands/foursquare.svg": [
		20733,
		20733
	],
	"./brands/free-code-camp.svg": [
		87803,
		87803
	],
	"./brands/freebsd.svg": [
		70791,
		70791
	],
	"./brands/fulcrum.svg": [
		57337,
		57337
	],
	"./brands/galactic-republic.svg": [
		43774,
		43774
	],
	"./brands/galactic-senate.svg": [
		68843,
		68843
	],
	"./brands/get-pocket.svg": [
		88024,
		88024
	],
	"./brands/gg-circle.svg": [
		96085,
		96085
	],
	"./brands/gg.svg": [
		86663,
		86663
	],
	"./brands/git-alt.svg": [
		83921,
		83921
	],
	"./brands/git-square.svg": [
		33286,
		33286
	],
	"./brands/git.svg": [
		81362,
		81362
	],
	"./brands/github-alt.svg": [
		96380,
		533
	],
	"./brands/github-square.svg": [
		62315,
		62315
	],
	"./brands/github.svg": [
		10254,
		10254
	],
	"./brands/gitkraken.svg": [
		5614,
		5614
	],
	"./brands/gitlab.svg": [
		91970,
		91970
	],
	"./brands/gitter.svg": [
		90562,
		90562
	],
	"./brands/glide-g.svg": [
		36526,
		36526
	],
	"./brands/glide.svg": [
		75014,
		75014
	],
	"./brands/gofore.svg": [
		41489,
		41489
	],
	"./brands/goodreads-g.svg": [
		11370,
		11370
	],
	"./brands/goodreads.svg": [
		42741,
		42741
	],
	"./brands/google-drive.svg": [
		37077,
		37077
	],
	"./brands/google-play.svg": [
		84099,
		84099
	],
	"./brands/google-plus-g.svg": [
		54877,
		54877
	],
	"./brands/google-plus-square.svg": [
		88569,
		88569
	],
	"./brands/google-plus.svg": [
		40835,
		40835
	],
	"./brands/google-wallet.svg": [
		46766,
		46766
	],
	"./brands/google.svg": [
		29926,
		29926
	],
	"./brands/gratipay.svg": [
		11274,
		11274
	],
	"./brands/grav.svg": [
		2339,
		2339
	],
	"./brands/gripfire.svg": [
		45185,
		45185
	],
	"./brands/grunt.svg": [
		61697,
		61697
	],
	"./brands/gulp.svg": [
		34314,
		34314
	],
	"./brands/hacker-news-square.svg": [
		97941,
		97941
	],
	"./brands/hacker-news.svg": [
		68143,
		68143
	],
	"./brands/hackerrank.svg": [
		44424,
		44424
	],
	"./brands/hips.svg": [
		44592,
		44592
	],
	"./brands/hire-a-helper.svg": [
		65307,
		65307
	],
	"./brands/hooli.svg": [
		48657,
		48657
	],
	"./brands/hornbill.svg": [
		73875,
		73875
	],
	"./brands/hotjar.svg": [
		74645,
		74645
	],
	"./brands/houzz.svg": [
		45088,
		45088
	],
	"./brands/html5.svg": [
		69214,
		69214
	],
	"./brands/hubspot.svg": [
		74812,
		74812
	],
	"./brands/ideal.svg": [
		85559,
		85559
	],
	"./brands/imdb.svg": [
		51166,
		51166
	],
	"./brands/instagram-square.svg": [
		67863,
		67863
	],
	"./brands/instagram.svg": [
		33639,
		33639
	],
	"./brands/intercom.svg": [
		23774,
		23774
	],
	"./brands/internet-explorer.svg": [
		79418,
		79418
	],
	"./brands/invision.svg": [
		54849,
		54849
	],
	"./brands/ioxhost.svg": [
		79582,
		79582
	],
	"./brands/itch-io.svg": [
		29864,
		29864
	],
	"./brands/itunes-note.svg": [
		197,
		197
	],
	"./brands/itunes.svg": [
		34560,
		34560
	],
	"./brands/java.svg": [
		9220,
		9220
	],
	"./brands/jedi-order.svg": [
		48102,
		68952
	],
	"./brands/jenkins.svg": [
		634,
		634
	],
	"./brands/jira.svg": [
		15656,
		15656
	],
	"./brands/joget.svg": [
		4933,
		4933
	],
	"./brands/joomla.svg": [
		57221,
		57221
	],
	"./brands/js-square.svg": [
		631,
		631
	],
	"./brands/js.svg": [
		69975,
		69975
	],
	"./brands/jsfiddle.svg": [
		49212,
		49212
	],
	"./brands/kaggle.svg": [
		47724,
		47724
	],
	"./brands/keybase.svg": [
		47892,
		47892
	],
	"./brands/keycdn.svg": [
		99915,
		99915
	],
	"./brands/kickstarter-k.svg": [
		69373,
		69373
	],
	"./brands/kickstarter.svg": [
		66234,
		66234
	],
	"./brands/korvue.svg": [
		72515,
		72515
	],
	"./brands/laravel.svg": [
		9825,
		9825
	],
	"./brands/lastfm-square.svg": [
		52492,
		52492
	],
	"./brands/lastfm.svg": [
		49937,
		49937
	],
	"./brands/leanpub.svg": [
		72627,
		72627
	],
	"./brands/less.svg": [
		26091,
		26091
	],
	"./brands/line.svg": [
		4811,
		4811
	],
	"./brands/linkedin-in.svg": [
		15640,
		15640
	],
	"./brands/linkedin.svg": [
		71977,
		71977
	],
	"./brands/linode.svg": [
		4886,
		4886
	],
	"./brands/linux.svg": [
		16619,
		16619
	],
	"./brands/lyft.svg": [
		88184,
		88184
	],
	"./brands/magento.svg": [
		99242,
		99242
	],
	"./brands/mailchimp.svg": [
		3058,
		3058
	],
	"./brands/mandalorian.svg": [
		78013,
		78013
	],
	"./brands/markdown.svg": [
		67608,
		67608
	],
	"./brands/mastodon.svg": [
		51966,
		51966
	],
	"./brands/maxcdn.svg": [
		7512,
		7512
	],
	"./brands/mdb.svg": [
		95853,
		95853
	],
	"./brands/medapps.svg": [
		58008,
		58008
	],
	"./brands/medium-m.svg": [
		98348,
		98348
	],
	"./brands/medium.svg": [
		50997,
		50997
	],
	"./brands/medrt.svg": [
		92223,
		92223
	],
	"./brands/meetup.svg": [
		50346,
		50346
	],
	"./brands/megaport.svg": [
		66579,
		66579
	],
	"./brands/mendeley.svg": [
		64799,
		64799
	],
	"./brands/microblog.svg": [
		57713,
		57713
	],
	"./brands/microsoft.svg": [
		38867,
		38867
	],
	"./brands/mix.svg": [
		36658,
		36658
	],
	"./brands/mixcloud.svg": [
		47193,
		47193
	],
	"./brands/mixer.svg": [
		99243,
		99243
	],
	"./brands/mizuni.svg": [
		48596,
		48596
	],
	"./brands/modx.svg": [
		90398,
		90398
	],
	"./brands/monero.svg": [
		7969,
		7969
	],
	"./brands/napster.svg": [
		73865,
		73865
	],
	"./brands/neos.svg": [
		17070,
		17070
	],
	"./brands/nimblr.svg": [
		2257,
		2257
	],
	"./brands/node-js.svg": [
		89617,
		89617
	],
	"./brands/node.svg": [
		22805,
		22805
	],
	"./brands/npm.svg": [
		73086,
		73086
	],
	"./brands/ns8.svg": [
		18594,
		18594
	],
	"./brands/nutritionix.svg": [
		9319,
		9319
	],
	"./brands/odnoklassniki-square.svg": [
		23218,
		23218
	],
	"./brands/odnoklassniki.svg": [
		77443,
		77443
	],
	"./brands/old-republic.svg": [
		69114,
		69114
	],
	"./brands/opencart.svg": [
		58294,
		58294
	],
	"./brands/openid.svg": [
		62672,
		62672
	],
	"./brands/opera.svg": [
		42745,
		42745
	],
	"./brands/optin-monster.svg": [
		28377,
		28377
	],
	"./brands/orcid.svg": [
		18409,
		18409
	],
	"./brands/osi.svg": [
		85096,
		85096
	],
	"./brands/page4.svg": [
		62840,
		62840
	],
	"./brands/pagelines.svg": [
		24917,
		24917
	],
	"./brands/palfed.svg": [
		25791,
		25791
	],
	"./brands/patreon.svg": [
		45352,
		45352
	],
	"./brands/paypal.svg": [
		44326,
		44326
	],
	"./brands/penny-arcade.svg": [
		14229,
		14229
	],
	"./brands/periscope.svg": [
		61121,
		61121
	],
	"./brands/phabricator.svg": [
		28826,
		28826
	],
	"./brands/phoenix-framework.svg": [
		1901,
		1901
	],
	"./brands/phoenix-squadron.svg": [
		47202,
		47202
	],
	"./brands/php.svg": [
		33072,
		33072
	],
	"./brands/pied-piper-alt.svg": [
		92611,
		92611
	],
	"./brands/pied-piper-hat.svg": [
		92033,
		92033
	],
	"./brands/pied-piper-pp.svg": [
		30658,
		30658
	],
	"./brands/pied-piper-square.svg": [
		32893,
		32893
	],
	"./brands/pied-piper.svg": [
		11619,
		11619
	],
	"./brands/pinterest-p.svg": [
		8813,
		8813
	],
	"./brands/pinterest-square.svg": [
		5051,
		5051
	],
	"./brands/pinterest.svg": [
		53493,
		53493
	],
	"./brands/playstation.svg": [
		82857,
		49997
	],
	"./brands/product-hunt.svg": [
		4451,
		4451
	],
	"./brands/pushed.svg": [
		55136,
		55136
	],
	"./brands/python.svg": [
		47093,
		47093
	],
	"./brands/qq.svg": [
		20214,
		20214
	],
	"./brands/quinscape.svg": [
		3320,
		3320
	],
	"./brands/quora.svg": [
		95970,
		95970
	],
	"./brands/r-project.svg": [
		1007,
		1007
	],
	"./brands/raspberry-pi.svg": [
		73773,
		73773
	],
	"./brands/ravelry.svg": [
		33041,
		33041
	],
	"./brands/react.svg": [
		60730,
		60730
	],
	"./brands/reacteurope.svg": [
		11305,
		11305
	],
	"./brands/readme.svg": [
		93337,
		93337
	],
	"./brands/rebel.svg": [
		8569,
		8569
	],
	"./brands/red-river.svg": [
		84545,
		84545
	],
	"./brands/reddit-alien.svg": [
		10515,
		10515
	],
	"./brands/reddit-square.svg": [
		95337,
		95337
	],
	"./brands/reddit.svg": [
		28700,
		28700
	],
	"./brands/redhat.svg": [
		5828,
		5828
	],
	"./brands/renren.svg": [
		68302,
		68302
	],
	"./brands/replyd.svg": [
		18552,
		18552
	],
	"./brands/researchgate.svg": [
		83827,
		83827
	],
	"./brands/resolving.svg": [
		62629,
		62629
	],
	"./brands/rev.svg": [
		58329,
		58329
	],
	"./brands/rocketchat.svg": [
		90296,
		90296
	],
	"./brands/rockrms.svg": [
		4348,
		4348
	],
	"./brands/safari.svg": [
		60651,
		60651
	],
	"./brands/salesforce.svg": [
		38725,
		38725
	],
	"./brands/sass.svg": [
		63801,
		63801
	],
	"./brands/schlix.svg": [
		20404,
		20404
	],
	"./brands/scribd.svg": [
		17992,
		17992
	],
	"./brands/searchengin.svg": [
		81490,
		81490
	],
	"./brands/sellcast.svg": [
		54254,
		54254
	],
	"./brands/sellsy.svg": [
		1047,
		1047
	],
	"./brands/servicestack.svg": [
		79646,
		79646
	],
	"./brands/shirtsinbulk.svg": [
		61611,
		61611
	],
	"./brands/shopify.svg": [
		76533,
		76533
	],
	"./brands/shopware.svg": [
		70337,
		70337
	],
	"./brands/simplybuilt.svg": [
		41375,
		41375
	],
	"./brands/sistrix.svg": [
		91701,
		91701
	],
	"./brands/sith.svg": [
		66870,
		66870
	],
	"./brands/sketch.svg": [
		85637,
		85637
	],
	"./brands/skyatlas.svg": [
		88443,
		88443
	],
	"./brands/skype.svg": [
		28961,
		28961
	],
	"./brands/slack-hash.svg": [
		93346,
		93346
	],
	"./brands/slack.svg": [
		90127,
		90127
	],
	"./brands/slideshare.svg": [
		16697,
		16697
	],
	"./brands/snapchat-ghost.svg": [
		54878,
		54878
	],
	"./brands/snapchat-square.svg": [
		19466,
		19466
	],
	"./brands/snapchat.svg": [
		20794,
		20794
	],
	"./brands/soundcloud.svg": [
		21029,
		21029
	],
	"./brands/sourcetree.svg": [
		49653,
		49653
	],
	"./brands/speakap.svg": [
		52290,
		52290
	],
	"./brands/speaker-deck.svg": [
		40409,
		40409
	],
	"./brands/spotify.svg": [
		78045,
		78045
	],
	"./brands/squarespace.svg": [
		15444,
		15444
	],
	"./brands/stack-exchange.svg": [
		33098,
		33098
	],
	"./brands/stack-overflow.svg": [
		54430,
		54430
	],
	"./brands/stackpath.svg": [
		67656,
		67656
	],
	"./brands/staylinked.svg": [
		76164,
		76164
	],
	"./brands/steam-square.svg": [
		67955,
		67955
	],
	"./brands/steam-symbol.svg": [
		34175,
		34175
	],
	"./brands/steam.svg": [
		58633,
		58633
	],
	"./brands/sticker-mule.svg": [
		25850,
		25850
	],
	"./brands/strava.svg": [
		91526,
		91526
	],
	"./brands/stripe-s.svg": [
		16325,
		16325
	],
	"./brands/stripe.svg": [
		87985,
		91771
	],
	"./brands/studiovinari.svg": [
		10623,
		10623
	],
	"./brands/stumbleupon-circle.svg": [
		47729,
		48102
	],
	"./brands/stumbleupon.svg": [
		69655,
		69655
	],
	"./brands/superpowers.svg": [
		80830,
		80830
	],
	"./brands/supple.svg": [
		70587,
		70587
	],
	"./brands/suse.svg": [
		67424,
		67424
	],
	"./brands/swift.svg": [
		50139,
		50139
	],
	"./brands/symfony.svg": [
		99517,
		99517
	],
	"./brands/teamspeak.svg": [
		55741,
		55741
	],
	"./brands/telegram-plane.svg": [
		30499,
		30499
	],
	"./brands/telegram.svg": [
		51410,
		51410
	],
	"./brands/tencent-weibo.svg": [
		82336,
		82336
	],
	"./brands/the-red-yeti.svg": [
		28557,
		28557
	],
	"./brands/themeco.svg": [
		68509,
		68509
	],
	"./brands/themeisle.svg": [
		24044,
		24044
	],
	"./brands/think-peaks.svg": [
		38326,
		38326
	],
	"./brands/trade-federation.svg": [
		87017,
		87017
	],
	"./brands/trello.svg": [
		73642,
		73642
	],
	"./brands/tripadvisor.svg": [
		35132,
		35132
	],
	"./brands/tumblr-square.svg": [
		95612,
		95612
	],
	"./brands/tumblr.svg": [
		44170,
		44170
	],
	"./brands/twitch.svg": [
		55056,
		55056
	],
	"./brands/twitter-square.svg": [
		67291,
		67291
	],
	"./brands/twitter.svg": [
		75561,
		75561
	],
	"./brands/typo3.svg": [
		32795,
		32795
	],
	"./brands/uber.svg": [
		19258,
		19258
	],
	"./brands/ubuntu.svg": [
		24721,
		24721
	],
	"./brands/uikit.svg": [
		15197,
		15197
	],
	"./brands/umbraco.svg": [
		33306,
		33306
	],
	"./brands/uniregistry.svg": [
		64376,
		64376
	],
	"./brands/unity.svg": [
		72866,
		72866
	],
	"./brands/untappd.svg": [
		85951,
		85951
	],
	"./brands/ups.svg": [
		72714,
		72714
	],
	"./brands/usb.svg": [
		67973,
		67973
	],
	"./brands/usps.svg": [
		5474,
		5474
	],
	"./brands/ussunnah.svg": [
		84471,
		84471
	],
	"./brands/vaadin.svg": [
		6093,
		6093
	],
	"./brands/viacoin.svg": [
		76610,
		76610
	],
	"./brands/viadeo-square.svg": [
		41604,
		41604
	],
	"./brands/viadeo.svg": [
		58582,
		58582
	],
	"./brands/viber.svg": [
		66709,
		66709
	],
	"./brands/vimeo-square.svg": [
		26871,
		26871
	],
	"./brands/vimeo-v.svg": [
		10375,
		10375
	],
	"./brands/vimeo.svg": [
		94588,
		94588
	],
	"./brands/vine.svg": [
		60772,
		60772
	],
	"./brands/vk.svg": [
		46151,
		46151
	],
	"./brands/vnv.svg": [
		17465,
		17465
	],
	"./brands/vuejs.svg": [
		20120,
		20120
	],
	"./brands/waze.svg": [
		82165,
		82165
	],
	"./brands/weebly.svg": [
		9808,
		9808
	],
	"./brands/weibo.svg": [
		89787,
		89787
	],
	"./brands/weixin.svg": [
		59270,
		59270
	],
	"./brands/whatsapp-square.svg": [
		16171,
		16171
	],
	"./brands/whatsapp.svg": [
		5214,
		5214
	],
	"./brands/whmcs.svg": [
		77885,
		77885
	],
	"./brands/wikipedia-w.svg": [
		80900,
		80900
	],
	"./brands/windows.svg": [
		61860,
		61860
	],
	"./brands/wix.svg": [
		15339,
		15339
	],
	"./brands/wizards-of-the-coast.svg": [
		20379,
		20379
	],
	"./brands/wolf-pack-battalion.svg": [
		62778,
		62778
	],
	"./brands/wordpress-simple.svg": [
		32092,
		32092
	],
	"./brands/wordpress.svg": [
		60647,
		60647
	],
	"./brands/wpbeginner.svg": [
		46235,
		46235
	],
	"./brands/wpexplorer.svg": [
		55117,
		55117
	],
	"./brands/wpforms.svg": [
		33453,
		33453
	],
	"./brands/wpressr.svg": [
		29189,
		29189
	],
	"./brands/xbox.svg": [
		72251,
		72251
	],
	"./brands/xing-square.svg": [
		22161,
		22161
	],
	"./brands/xing.svg": [
		39581,
		39581
	],
	"./brands/y-combinator.svg": [
		56856,
		56856
	],
	"./brands/yahoo.svg": [
		36527,
		36527
	],
	"./brands/yammer.svg": [
		62996,
		62996
	],
	"./brands/yandex-international.svg": [
		92709,
		92709
	],
	"./brands/yandex.svg": [
		66200,
		66200
	],
	"./brands/yarn.svg": [
		47117,
		47117
	],
	"./brands/yelp.svg": [
		14033,
		14033
	],
	"./brands/yoast.svg": [
		12551,
		12551
	],
	"./brands/youtube-square.svg": [
		66958,
		66958
	],
	"./brands/youtube.svg": [
		37488,
		37488
	],
	"./brands/zhihu.svg": [
		92487,
		92487
	],
	"./case/contentStrategy.svg": [
		77198,
		77198
	],
	"./case/cta.svg": [
		46044,
		46044
	],
	"./case/customerSupport.svg": [
		78724,
		78724
	],
	"./case/employeeEducation.svg": [
		84909,
		84909
	],
	"./case/inVideoNavigation.svg": [
		52820,
		52820
	],
	"./case/leadGeneration.svg": [
		99562,
		99562
	],
	"./case/personalization.svg": [
		15272,
		15272
	],
	"./case/preOnboarding.svg": [
		75939,
		75939
	],
	"./case/retention.svg": [
		7482,
		7482
	],
	"./case/videoProduction.svg": [
		13135,
		13135
	],
	"./fab/analitics.svg": [
		60646,
		60646
	],
	"./fab/fabLogo.svg": [
		65244,
		65244
	],
	"./fab/plugAndPlay.svg": [
		88820,
		88820
	],
	"./fab/reelsNStories.svg": [
		83068,
		83068
	],
	"./koel/audioPersonalization.svg": [
		56278,
		56278
	],
	"./koel/multilanguageSupport.svg": [
		34451,
		34451
	],
	"./koel/textToSpeech.svg": [
		31468,
		31468
	],
	"./light/abacus.svg": [
		86535,
		86535
	],
	"./light/acorn.svg": [
		97510,
		97510
	],
	"./light/ad.svg": [
		34454,
		34454
	],
	"./light/address-book.svg": [
		48049,
		48049
	],
	"./light/address-card.svg": [
		84841,
		84841
	],
	"./light/adjust.svg": [
		70477,
		70477
	],
	"./light/air-conditioner.svg": [
		88802,
		88802
	],
	"./light/air-freshener.svg": [
		73329,
		73329
	],
	"./light/alarm-clock.svg": [
		60430,
		60430
	],
	"./light/alarm-exclamation.svg": [
		32394,
		32394
	],
	"./light/alarm-plus.svg": [
		49364,
		49364
	],
	"./light/alarm-snooze.svg": [
		92112,
		92112
	],
	"./light/album-collection.svg": [
		91176,
		91176
	],
	"./light/album.svg": [
		29932,
		29932
	],
	"./light/alicorn.svg": [
		1223,
		1223
	],
	"./light/alien-monster.svg": [
		16230,
		16230
	],
	"./light/alien.svg": [
		17755,
		17755
	],
	"./light/align-center.svg": [
		97336,
		97336
	],
	"./light/align-justify.svg": [
		53402,
		53402
	],
	"./light/align-left.svg": [
		23121,
		23121
	],
	"./light/align-right.svg": [
		50358,
		50358
	],
	"./light/align-slash.svg": [
		66185,
		66185
	],
	"./light/allergies.svg": [
		19778,
		19778
	],
	"./light/ambulance.svg": [
		80286,
		80286
	],
	"./light/american-sign-language-interpreting.svg": [
		69508,
		69508
	],
	"./light/amp-guitar.svg": [
		46361,
		46361
	],
	"./light/analytics.svg": [
		62187,
		62187
	],
	"./light/anchor.svg": [
		57956,
		57956
	],
	"./light/angel.svg": [
		14852,
		14852
	],
	"./light/angle-double-down.svg": [
		11672,
		11672
	],
	"./light/angle-double-left.svg": [
		13869,
		13869
	],
	"./light/angle-double-right.svg": [
		47434,
		47434
	],
	"./light/angle-double-up.svg": [
		31277,
		31277
	],
	"./light/angle-down.svg": [
		96960,
		96960
	],
	"./light/angle-left.svg": [
		66805,
		66805
	],
	"./light/angle-right.svg": [
		9244,
		9244
	],
	"./light/angle-up.svg": [
		21848,
		21848
	],
	"./light/angry.svg": [
		21101,
		21101
	],
	"./light/ankh.svg": [
		24850,
		24850
	],
	"./light/apple-alt.svg": [
		26648,
		26648
	],
	"./light/apple-crate.svg": [
		79096,
		79096
	],
	"./light/archive.svg": [
		51455,
		51455
	],
	"./light/archway.svg": [
		76350,
		76350
	],
	"./light/arrow-alt-circle-down.svg": [
		66784,
		66784
	],
	"./light/arrow-alt-circle-left.svg": [
		96447,
		96447
	],
	"./light/arrow-alt-circle-right.svg": [
		77979,
		77979
	],
	"./light/arrow-alt-circle-up.svg": [
		28155,
		28155
	],
	"./light/arrow-alt-down.svg": [
		10708,
		10708
	],
	"./light/arrow-alt-from-bottom.svg": [
		32528,
		32528
	],
	"./light/arrow-alt-from-left.svg": [
		32435,
		32435
	],
	"./light/arrow-alt-from-right.svg": [
		91025,
		91025
	],
	"./light/arrow-alt-from-top.svg": [
		38879,
		38879
	],
	"./light/arrow-alt-left.svg": [
		15263,
		15263
	],
	"./light/arrow-alt-right.svg": [
		90712,
		90712
	],
	"./light/arrow-alt-square-down.svg": [
		45842,
		45842
	],
	"./light/arrow-alt-square-left.svg": [
		86382,
		86382
	],
	"./light/arrow-alt-square-right.svg": [
		19955,
		19955
	],
	"./light/arrow-alt-square-up.svg": [
		60192,
		60192
	],
	"./light/arrow-alt-to-bottom.svg": [
		95016,
		95016
	],
	"./light/arrow-alt-to-left.svg": [
		5253,
		5253
	],
	"./light/arrow-alt-to-right.svg": [
		86410,
		86410
	],
	"./light/arrow-alt-to-top.svg": [
		30534,
		30534
	],
	"./light/arrow-alt-up.svg": [
		39471,
		39471
	],
	"./light/arrow-circle-down.svg": [
		19914,
		19914
	],
	"./light/arrow-circle-left.svg": [
		86331,
		86331
	],
	"./light/arrow-circle-right.svg": [
		38745,
		38745
	],
	"./light/arrow-circle-up.svg": [
		73035,
		73035
	],
	"./light/arrow-down-to-line.svg": [
		61215,
		61215
	],
	"./light/arrow-down.svg": [
		66701,
		66701
	],
	"./light/arrow-from-bottom.svg": [
		61279,
		61279
	],
	"./light/arrow-from-left.svg": [
		55097,
		55097
	],
	"./light/arrow-from-right.svg": [
		64252,
		64252
	],
	"./light/arrow-from-top.svg": [
		74089,
		74089
	],
	"./light/arrow-left.svg": [
		18109,
		18109
	],
	"./light/arrow-right.svg": [
		31478,
		31478
	],
	"./light/arrow-square-down.svg": [
		34945,
		34945
	],
	"./light/arrow-square-left.svg": [
		54085,
		54085
	],
	"./light/arrow-square-right.svg": [
		6411,
		6411
	],
	"./light/arrow-square-up.svg": [
		20229,
		20229
	],
	"./light/arrow-to-bottom.svg": [
		79889,
		79889
	],
	"./light/arrow-to-left.svg": [
		12832,
		12832
	],
	"./light/arrow-to-right.svg": [
		9735,
		9735
	],
	"./light/arrow-to-top.svg": [
		7080,
		7080
	],
	"./light/arrow-up.svg": [
		46565,
		46565
	],
	"./light/arrows-alt-h.svg": [
		20497,
		20497
	],
	"./light/arrows-alt-v.svg": [
		33749,
		33749
	],
	"./light/arrows-alt.svg": [
		84582,
		84582
	],
	"./light/arrows-h.svg": [
		41408,
		41408
	],
	"./light/arrows-v.svg": [
		55523,
		55523
	],
	"./light/arrows.svg": [
		1721,
		1721
	],
	"./light/assistive-listening-systems.svg": [
		4217,
		4217
	],
	"./light/asterisk.svg": [
		39640,
		39640
	],
	"./light/at.svg": [
		33833,
		33833
	],
	"./light/atlas.svg": [
		1560,
		1560
	],
	"./light/atom-alt.svg": [
		95990,
		95990
	],
	"./light/atom.svg": [
		85158,
		85158
	],
	"./light/audio-description.svg": [
		41975,
		41975
	],
	"./light/award.svg": [
		17194,
		17194
	],
	"./light/axe-battle.svg": [
		54814,
		54814
	],
	"./light/axe.svg": [
		15625,
		15625
	],
	"./light/baby-carriage.svg": [
		93153,
		93153
	],
	"./light/baby.svg": [
		29366,
		29366
	],
	"./light/backpack.svg": [
		24362,
		24362
	],
	"./light/backspace.svg": [
		43029,
		43029
	],
	"./light/backward.svg": [
		46705,
		46705
	],
	"./light/bacon.svg": [
		89693,
		1344
	],
	"./light/bacteria.svg": [
		14939,
		14939
	],
	"./light/bacterium.svg": [
		97715,
		97715
	],
	"./light/badge-check.svg": [
		93461,
		93461
	],
	"./light/badge-dollar.svg": [
		61321,
		61321
	],
	"./light/badge-percent.svg": [
		94668,
		94668
	],
	"./light/badge-sheriff.svg": [
		75134,
		75134
	],
	"./light/badge.svg": [
		79233,
		79233
	],
	"./light/badger-honey.svg": [
		25940,
		25940
	],
	"./light/bags-shopping.svg": [
		242,
		242
	],
	"./light/bahai.svg": [
		99112,
		99112
	],
	"./light/balance-scale-left.svg": [
		19205,
		19205
	],
	"./light/balance-scale-right.svg": [
		74281,
		74281
	],
	"./light/balance-scale.svg": [
		83969,
		83969
	],
	"./light/ball-pile.svg": [
		22273,
		22273
	],
	"./light/ballot-check.svg": [
		84248,
		84248
	],
	"./light/ballot.svg": [
		62129,
		62129
	],
	"./light/ban.svg": [
		97180,
		97180
	],
	"./light/band-aid.svg": [
		1590,
		1590
	],
	"./light/banjo.svg": [
		40997,
		40997
	],
	"./light/barcode-alt.svg": [
		2805,
		2805
	],
	"./light/barcode-read.svg": [
		95682,
		95682
	],
	"./light/barcode-scan.svg": [
		63257,
		63257
	],
	"./light/barcode.svg": [
		84669,
		84669
	],
	"./light/bars.svg": [
		75872,
		75872
	],
	"./light/baseball-ball.svg": [
		85014,
		85014
	],
	"./light/baseball.svg": [
		92921,
		92921
	],
	"./light/basketball-ball.svg": [
		52862,
		52862
	],
	"./light/basketball-hoop.svg": [
		3880,
		3880
	],
	"./light/bat.svg": [
		52433,
		52433
	],
	"./light/bath.svg": [
		25998,
		25998
	],
	"./light/battery-bolt.svg": [
		91105,
		91105
	],
	"./light/battery-empty.svg": [
		40578,
		40578
	],
	"./light/battery-full.svg": [
		3356,
		3356
	],
	"./light/battery-half.svg": [
		30804,
		30804
	],
	"./light/battery-quarter.svg": [
		13340,
		13340
	],
	"./light/battery-slash.svg": [
		28287,
		28287
	],
	"./light/battery-three-quarters.svg": [
		75123,
		75123
	],
	"./light/bed-alt.svg": [
		12034,
		12034
	],
	"./light/bed-bunk.svg": [
		45595,
		45595
	],
	"./light/bed-empty.svg": [
		53910,
		53910
	],
	"./light/bed.svg": [
		34172,
		34172
	],
	"./light/beer.svg": [
		16192,
		16192
	],
	"./light/bell-exclamation.svg": [
		81763,
		81763
	],
	"./light/bell-on.svg": [
		12628,
		12628
	],
	"./light/bell-plus.svg": [
		13903,
		13903
	],
	"./light/bell-school-slash.svg": [
		6269,
		6269
	],
	"./light/bell-school.svg": [
		8592,
		8592
	],
	"./light/bell-slash.svg": [
		11201,
		11201
	],
	"./light/bell.svg": [
		72387,
		72387
	],
	"./light/bells.svg": [
		36549,
		36549
	],
	"./light/betamax.svg": [
		31438,
		31438
	],
	"./light/bezier-curve.svg": [
		30725,
		30725
	],
	"./light/bible.svg": [
		8298,
		8298
	],
	"./light/bicycle.svg": [
		62222,
		62222
	],
	"./light/biking-mountain.svg": [
		79970,
		79970
	],
	"./light/biking.svg": [
		42732,
		42732
	],
	"./light/binoculars.svg": [
		35355,
		35355
	],
	"./light/biohazard.svg": [
		38706,
		38706
	],
	"./light/birthday-cake.svg": [
		81980,
		81980
	],
	"./light/blanket.svg": [
		23196,
		23196
	],
	"./light/blender-phone.svg": [
		42159,
		42159
	],
	"./light/blender.svg": [
		46149,
		46149
	],
	"./light/blind.svg": [
		27833,
		27833
	],
	"./light/blinds-open.svg": [
		52864,
		52864
	],
	"./light/blinds-raised.svg": [
		40720,
		40720
	],
	"./light/blinds.svg": [
		20938,
		20938
	],
	"./light/blog.svg": [
		97831,
		97831
	],
	"./light/bold.svg": [
		93360,
		93360
	],
	"./light/bolt.svg": [
		89466,
		89466
	],
	"./light/bomb.svg": [
		72401,
		72401
	],
	"./light/bone-break.svg": [
		17508,
		17508
	],
	"./light/bone.svg": [
		44882,
		44882
	],
	"./light/bong.svg": [
		63005,
		63005
	],
	"./light/book-alt.svg": [
		35456,
		35456
	],
	"./light/book-dead.svg": [
		48055,
		48055
	],
	"./light/book-heart.svg": [
		20580,
		20580
	],
	"./light/book-medical.svg": [
		94346,
		94346
	],
	"./light/book-open.svg": [
		72939,
		72939
	],
	"./light/book-reader.svg": [
		85023,
		85023
	],
	"./light/book-spells.svg": [
		94343,
		10902
	],
	"./light/book-user.svg": [
		32739,
		32739
	],
	"./light/book.svg": [
		51324,
		96380
	],
	"./light/bookmark.svg": [
		43806,
		43806
	],
	"./light/books-medical.svg": [
		9626,
		9626
	],
	"./light/books.svg": [
		53255,
		53255
	],
	"./light/boombox.svg": [
		87556,
		87556
	],
	"./light/boot.svg": [
		14596,
		14596
	],
	"./light/booth-curtain.svg": [
		55415,
		55415
	],
	"./light/border-all.svg": [
		96257,
		96257
	],
	"./light/border-bottom.svg": [
		28202,
		28202
	],
	"./light/border-center-h.svg": [
		84507,
		84507
	],
	"./light/border-center-v.svg": [
		2322,
		2322
	],
	"./light/border-inner.svg": [
		96641,
		96641
	],
	"./light/border-left.svg": [
		42407,
		42407
	],
	"./light/border-none.svg": [
		38007,
		38007
	],
	"./light/border-outer.svg": [
		83880,
		83880
	],
	"./light/border-right.svg": [
		26137,
		26137
	],
	"./light/border-style-alt.svg": [
		87793,
		87793
	],
	"./light/border-style.svg": [
		48422,
		48422
	],
	"./light/border-top.svg": [
		7501,
		7501
	],
	"./light/bow-arrow.svg": [
		53386,
		28812
	],
	"./light/bowling-ball.svg": [
		53553,
		53553
	],
	"./light/bowling-pins.svg": [
		57265,
		57265
	],
	"./light/box-alt.svg": [
		13102,
		13102
	],
	"./light/box-ballot.svg": [
		65370,
		65370
	],
	"./light/box-check.svg": [
		90336,
		90336
	],
	"./light/box-fragile.svg": [
		30278,
		30278
	],
	"./light/box-full.svg": [
		13992,
		13992
	],
	"./light/box-heart.svg": [
		76278,
		76278
	],
	"./light/box-open.svg": [
		96920,
		96920
	],
	"./light/box-tissue.svg": [
		42000,
		42000
	],
	"./light/box-up.svg": [
		20382,
		20382
	],
	"./light/box-usd.svg": [
		58280,
		58280
	],
	"./light/box.svg": [
		96739,
		96739
	],
	"./light/boxes-alt.svg": [
		12855,
		12855
	],
	"./light/boxes.svg": [
		7607,
		7607
	],
	"./light/boxing-glove.svg": [
		29216,
		29216
	],
	"./light/brackets-curly.svg": [
		46299,
		46299
	],
	"./light/brackets.svg": [
		31236,
		31236
	],
	"./light/braille.svg": [
		32060,
		32060
	],
	"./light/brain.svg": [
		87246,
		87246
	],
	"./light/bread-loaf.svg": [
		448,
		448
	],
	"./light/bread-slice.svg": [
		87127,
		87127
	],
	"./light/briefcase-medical.svg": [
		12157,
		12157
	],
	"./light/briefcase.svg": [
		78105,
		78105
	],
	"./light/bring-forward.svg": [
		82922,
		53368
	],
	"./light/bring-front.svg": [
		63758,
		63758
	],
	"./light/broadcast-tower.svg": [
		75625,
		75625
	],
	"./light/broom.svg": [
		2384,
		2384
	],
	"./light/browser.svg": [
		39591,
		39591
	],
	"./light/brush.svg": [
		7753,
		7753
	],
	"./light/bug.svg": [
		977,
		977
	],
	"./light/building.svg": [
		14818,
		14818
	],
	"./light/bullhorn.svg": [
		57387,
		57387
	],
	"./light/bullseye-arrow.svg": [
		88998,
		88998
	],
	"./light/bullseye-pointer.svg": [
		16064,
		16064
	],
	"./light/bullseye.svg": [
		82563,
		82563
	],
	"./light/burger-soda.svg": [
		61803,
		61803
	],
	"./light/burn.svg": [
		23693,
		23693
	],
	"./light/burrito.svg": [
		72974,
		72974
	],
	"./light/bus-alt.svg": [
		62684,
		95939
	],
	"./light/bus-school.svg": [
		57581,
		57581
	],
	"./light/bus.svg": [
		26497,
		26497
	],
	"./light/business-time.svg": [
		80458,
		80458
	],
	"./light/cabinet-filing.svg": [
		47902,
		47902
	],
	"./light/cactus.svg": [
		54613,
		54613
	],
	"./light/calculator-alt.svg": [
		36289,
		36289
	],
	"./light/calculator.svg": [
		52413,
		52413
	],
	"./light/calendar-alt.svg": [
		69518,
		69518
	],
	"./light/calendar-check.svg": [
		5987,
		5987
	],
	"./light/calendar-day.svg": [
		88021,
		88021
	],
	"./light/calendar-edit.svg": [
		82641,
		82641
	],
	"./light/calendar-exclamation.svg": [
		55011,
		55011
	],
	"./light/calendar-minus.svg": [
		37416,
		37416
	],
	"./light/calendar-plus.svg": [
		16026,
		16026
	],
	"./light/calendar-star.svg": [
		73984,
		73984
	],
	"./light/calendar-times.svg": [
		19763,
		19763
	],
	"./light/calendar-week.svg": [
		61492,
		61492
	],
	"./light/calendar.svg": [
		60095,
		60095
	],
	"./light/camcorder.svg": [
		75583,
		75583
	],
	"./light/camera-alt.svg": [
		17330,
		17330
	],
	"./light/camera-home.svg": [
		52560,
		52560
	],
	"./light/camera-movie.svg": [
		51302,
		51302
	],
	"./light/camera-polaroid.svg": [
		72226,
		72226
	],
	"./light/camera-retro.svg": [
		3240,
		3240
	],
	"./light/camera.svg": [
		47465,
		47465
	],
	"./light/campfire.svg": [
		65302,
		65302
	],
	"./light/campground.svg": [
		22509,
		22509
	],
	"./light/candle-holder.svg": [
		15997,
		15997
	],
	"./light/candy-cane.svg": [
		2218,
		2218
	],
	"./light/candy-corn.svg": [
		34291,
		34291
	],
	"./light/cannabis.svg": [
		60017,
		60017
	],
	"./light/capsules.svg": [
		80633,
		80633
	],
	"./light/car-alt.svg": [
		4962,
		4962
	],
	"./light/car-battery.svg": [
		85512,
		85512
	],
	"./light/car-building.svg": [
		10719,
		10719
	],
	"./light/car-bump.svg": [
		24285,
		24285
	],
	"./light/car-bus.svg": [
		68440,
		68440
	],
	"./light/car-crash.svg": [
		86534,
		86534
	],
	"./light/car-garage.svg": [
		82779,
		82779
	],
	"./light/car-mechanic.svg": [
		51505,
		51505
	],
	"./light/car-side.svg": [
		79438,
		79438
	],
	"./light/car-tilt.svg": [
		93384,
		93384
	],
	"./light/car-wash.svg": [
		86830,
		86830
	],
	"./light/car.svg": [
		42128,
		42128
	],
	"./light/caravan-alt.svg": [
		10511,
		10511
	],
	"./light/caravan.svg": [
		77086,
		77086
	],
	"./light/caret-circle-down.svg": [
		96948,
		96948
	],
	"./light/caret-circle-left.svg": [
		33557,
		33557
	],
	"./light/caret-circle-right.svg": [
		31240,
		31240
	],
	"./light/caret-circle-up.svg": [
		39926,
		39926
	],
	"./light/caret-down.svg": [
		11411,
		11411
	],
	"./light/caret-left.svg": [
		69330,
		69330
	],
	"./light/caret-right.svg": [
		17002,
		17002
	],
	"./light/caret-square-down.svg": [
		40530,
		40530
	],
	"./light/caret-square-left.svg": [
		40291,
		40291
	],
	"./light/caret-square-right.svg": [
		5864,
		5864
	],
	"./light/caret-square-up.svg": [
		27344,
		27344
	],
	"./light/caret-up.svg": [
		2318,
		2318
	],
	"./light/carrot.svg": [
		54417,
		54417
	],
	"./light/cars.svg": [
		97807,
		97807
	],
	"./light/cart-arrow-down.svg": [
		52136,
		52136
	],
	"./light/cart-plus.svg": [
		36854,
		36854
	],
	"./light/cash-register.svg": [
		72085,
		72085
	],
	"./light/cassette-tape.svg": [
		77515,
		77515
	],
	"./light/cat-space.svg": [
		34206,
		34206
	],
	"./light/cat.svg": [
		19365,
		19365
	],
	"./light/cauldron.svg": [
		23846,
		23846
	],
	"./light/cctv.svg": [
		71481,
		71481
	],
	"./light/certificate.svg": [
		59248,
		59248
	],
	"./light/chair-office.svg": [
		24334,
		24334
	],
	"./light/chair.svg": [
		79522,
		79522
	],
	"./light/chalkboard-teacher.svg": [
		61756,
		61756
	],
	"./light/chalkboard.svg": [
		87503,
		87503
	],
	"./light/charging-station.svg": [
		28048,
		28048
	],
	"./light/chart-area.svg": [
		83429,
		83429
	],
	"./light/chart-bar.svg": [
		9743,
		9743
	],
	"./light/chart-line-down.svg": [
		24413,
		24413
	],
	"./light/chart-line.svg": [
		16228,
		16228
	],
	"./light/chart-network.svg": [
		3464,
		3464
	],
	"./light/chart-pie-alt.svg": [
		34007,
		34007
	],
	"./light/chart-pie.svg": [
		46030,
		46030
	],
	"./light/chart-scatter.svg": [
		1772,
		1772
	],
	"./light/check-circle.svg": [
		9653,
		9653
	],
	"./light/check-double.svg": [
		17710,
		17710
	],
	"./light/check-square.svg": [
		20449,
		20449
	],
	"./light/check.svg": [
		53650
	],
	"./light/cheese-swiss.svg": [
		16809,
		16809
	],
	"./light/cheese.svg": [
		98202,
		98202
	],
	"./light/cheeseburger.svg": [
		49269,
		49269
	],
	"./light/chess-bishop-alt.svg": [
		22639,
		22639
	],
	"./light/chess-bishop.svg": [
		28424,
		28424
	],
	"./light/chess-board.svg": [
		3065,
		3065
	],
	"./light/chess-clock-alt.svg": [
		18611,
		18611
	],
	"./light/chess-clock.svg": [
		31197,
		31197
	],
	"./light/chess-king-alt.svg": [
		48629,
		48629
	],
	"./light/chess-king.svg": [
		87328,
		87328
	],
	"./light/chess-knight-alt.svg": [
		60738,
		60738
	],
	"./light/chess-knight.svg": [
		52385,
		52385
	],
	"./light/chess-pawn-alt.svg": [
		88335,
		88335
	],
	"./light/chess-pawn.svg": [
		58663,
		58663
	],
	"./light/chess-queen-alt.svg": [
		89503,
		89503
	],
	"./light/chess-queen.svg": [
		21304,
		21304
	],
	"./light/chess-rook-alt.svg": [
		97749,
		97749
	],
	"./light/chess-rook.svg": [
		22914,
		22914
	],
	"./light/chess.svg": [
		12346,
		12346
	],
	"./light/chevron-circle-down.svg": [
		30759,
		30759
	],
	"./light/chevron-circle-left.svg": [
		11418,
		11418
	],
	"./light/chevron-circle-right.svg": [
		37777,
		37777
	],
	"./light/chevron-circle-up.svg": [
		85540,
		85540
	],
	"./light/chevron-double-down.svg": [
		13124,
		13124
	],
	"./light/chevron-double-left.svg": [
		64707,
		64707
	],
	"./light/chevron-double-right.svg": [
		33350,
		33350
	],
	"./light/chevron-double-up.svg": [
		9251,
		9251
	],
	"./light/chevron-down.svg": [
		98645,
		98645
	],
	"./light/chevron-left.svg": [
		55234,
		55234
	],
	"./light/chevron-right.svg": [
		93375,
		93375
	],
	"./light/chevron-square-down.svg": [
		25659,
		25659
	],
	"./light/chevron-square-left.svg": [
		59293,
		59293
	],
	"./light/chevron-square-right.svg": [
		15056,
		15056
	],
	"./light/chevron-square-up.svg": [
		65366,
		65366
	],
	"./light/chevron-up.svg": [
		6371,
		6371
	],
	"./light/child.svg": [
		70408,
		70408
	],
	"./light/chimney.svg": [
		9690,
		9690
	],
	"./light/church.svg": [
		74769,
		74769
	],
	"./light/circle-notch.svg": [
		51133,
		51133
	],
	"./light/circle.svg": [
		45646,
		45646
	],
	"./light/city.svg": [
		19741,
		19741
	],
	"./light/clarinet.svg": [
		24979,
		24979
	],
	"./light/claw-marks.svg": [
		39839,
		39839
	],
	"./light/clinic-medical.svg": [
		13935,
		13935
	],
	"./light/clipboard-check.svg": [
		28312,
		28312
	],
	"./light/clipboard-list-check.svg": [
		65210,
		65210
	],
	"./light/clipboard-list.svg": [
		25994,
		25994
	],
	"./light/clipboard-prescription.svg": [
		85965,
		85965
	],
	"./light/clipboard-user.svg": [
		72349,
		98951
	],
	"./light/clipboard.svg": [
		61966,
		61966
	],
	"./light/clock.svg": [
		39979,
		39979
	],
	"./light/clone.svg": [
		21064,
		21064
	],
	"./light/closed-captioning.svg": [
		4776,
		4776
	],
	"./light/cloud-download-alt.svg": [
		95028,
		95028
	],
	"./light/cloud-download.svg": [
		36857,
		36857
	],
	"./light/cloud-drizzle.svg": [
		71278,
		71278
	],
	"./light/cloud-hail-mixed.svg": [
		12949,
		12949
	],
	"./light/cloud-hail.svg": [
		19627,
		19627
	],
	"./light/cloud-meatball.svg": [
		35028,
		35028
	],
	"./light/cloud-moon-rain.svg": [
		86372,
		86372
	],
	"./light/cloud-moon.svg": [
		60983,
		60983
	],
	"./light/cloud-music.svg": [
		21465,
		21465
	],
	"./light/cloud-rain.svg": [
		92316,
		92316
	],
	"./light/cloud-rainbow.svg": [
		57057,
		85418
	],
	"./light/cloud-showers-heavy.svg": [
		53889,
		53889
	],
	"./light/cloud-showers.svg": [
		64310,
		64310
	],
	"./light/cloud-sleet.svg": [
		79352,
		79352
	],
	"./light/cloud-snow.svg": [
		75073,
		75073
	],
	"./light/cloud-sun-rain.svg": [
		51268,
		51268
	],
	"./light/cloud-sun.svg": [
		85721,
		85721
	],
	"./light/cloud-upload-alt.svg": [
		7277,
		7277
	],
	"./light/cloud-upload.svg": [
		29007,
		29007
	],
	"./light/cloud.svg": [
		45949,
		45949
	],
	"./light/clouds-moon.svg": [
		61514,
		61514
	],
	"./light/clouds-sun.svg": [
		34710,
		34710
	],
	"./light/clouds.svg": [
		64599,
		64599
	],
	"./light/club.svg": [
		89467,
		89467
	],
	"./light/cocktail.svg": [
		2804,
		2804
	],
	"./light/code-branch.svg": [
		60001,
		60001
	],
	"./light/code-commit.svg": [
		39182,
		39182
	],
	"./light/code-merge.svg": [
		40135,
		40135
	],
	"./light/code.svg": [
		66900,
		66900
	],
	"./light/coffee-pot.svg": [
		55811,
		55811
	],
	"./light/coffee-togo.svg": [
		76437,
		76437
	],
	"./light/coffee.svg": [
		84135,
		84135
	],
	"./light/coffin-cross.svg": [
		25091,
		25091
	],
	"./light/coffin.svg": [
		60236,
		60236
	],
	"./light/cog.svg": [
		64327,
		64327
	],
	"./light/cogs.svg": [
		45362,
		45362
	],
	"./light/coin.svg": [
		34540,
		34540
	],
	"./light/coins.svg": [
		41174,
		41174
	],
	"./light/columns.svg": [
		61025,
		61025
	],
	"./light/comet.svg": [
		1341,
		1341
	],
	"./light/comment-alt-check.svg": [
		97098,
		97098
	],
	"./light/comment-alt-dollar.svg": [
		36993,
		36993
	],
	"./light/comment-alt-dots.svg": [
		72384,
		72384
	],
	"./light/comment-alt-edit.svg": [
		17502,
		17502
	],
	"./light/comment-alt-exclamation.svg": [
		69464,
		69464
	],
	"./light/comment-alt-lines.svg": [
		63617,
		63617
	],
	"./light/comment-alt-medical.svg": [
		62146,
		62146
	],
	"./light/comment-alt-minus.svg": [
		85328,
		85328
	],
	"./light/comment-alt-music.svg": [
		49401,
		49401
	],
	"./light/comment-alt-plus.svg": [
		11374,
		11374
	],
	"./light/comment-alt-slash.svg": [
		24148,
		24148
	],
	"./light/comment-alt-smile.svg": [
		78523,
		78523
	],
	"./light/comment-alt-times.svg": [
		68151,
		68151
	],
	"./light/comment-alt.svg": [
		56281,
		56281
	],
	"./light/comment-check.svg": [
		16707,
		16707
	],
	"./light/comment-dollar.svg": [
		43944,
		43944
	],
	"./light/comment-dots.svg": [
		84266,
		84266
	],
	"./light/comment-edit.svg": [
		72762,
		72762
	],
	"./light/comment-exclamation.svg": [
		52545,
		52545
	],
	"./light/comment-lines.svg": [
		58774,
		58774
	],
	"./light/comment-medical.svg": [
		37249,
		37249
	],
	"./light/comment-minus.svg": [
		9294,
		9294
	],
	"./light/comment-music.svg": [
		57933,
		57933
	],
	"./light/comment-plus.svg": [
		51483,
		51483
	],
	"./light/comment-slash.svg": [
		70812,
		70812
	],
	"./light/comment-smile.svg": [
		78704,
		78704
	],
	"./light/comment-times.svg": [
		22847,
		22847
	],
	"./light/comment.svg": [
		30389,
		30389
	],
	"./light/comments-alt-dollar.svg": [
		31895,
		31895
	],
	"./light/comments-alt.svg": [
		99837,
		99837
	],
	"./light/comments-dollar.svg": [
		89794,
		89794
	],
	"./light/comments.svg": [
		72207,
		72207
	],
	"./light/compact-disc.svg": [
		72989,
		72989
	],
	"./light/compass-slash.svg": [
		47391,
		47391
	],
	"./light/compass.svg": [
		12270,
		12270
	],
	"./light/compress-alt.svg": [
		68006,
		68006
	],
	"./light/compress-arrows-alt.svg": [
		77233,
		77233
	],
	"./light/compress-wide.svg": [
		50009,
		50009
	],
	"./light/compress.svg": [
		30069,
		30069
	],
	"./light/computer-classic.svg": [
		65064,
		65064
	],
	"./light/computer-speaker.svg": [
		97073,
		97073
	],
	"./light/concierge-bell.svg": [
		22813,
		22813
	],
	"./light/construction.svg": [
		17142,
		17142
	],
	"./light/container-storage.svg": [
		33605,
		33605
	],
	"./light/conveyor-belt-alt.svg": [
		63166,
		63166
	],
	"./light/conveyor-belt.svg": [
		24725,
		24725
	],
	"./light/cookie-bite.svg": [
		9347,
		9347
	],
	"./light/cookie.svg": [
		11156,
		11156
	],
	"./light/copy.svg": [
		67995
	],
	"./light/copyright.svg": [
		92993,
		92993
	],
	"./light/corn.svg": [
		48135,
		48135
	],
	"./light/couch.svg": [
		50101,
		50101
	],
	"./light/cow.svg": [
		19360,
		19360
	],
	"./light/cowbell-more.svg": [
		34932,
		34932
	],
	"./light/cowbell.svg": [
		41020,
		41020
	],
	"./light/credit-card-blank.svg": [
		18379,
		18379
	],
	"./light/credit-card-front.svg": [
		85518,
		85518
	],
	"./light/credit-card.svg": [
		47961,
		47961
	],
	"./light/cricket.svg": [
		51626,
		51626
	],
	"./light/croissant.svg": [
		29017,
		29017
	],
	"./light/crop-alt.svg": [
		57378,
		57378
	],
	"./light/crop.svg": [
		11063,
		11063
	],
	"./light/cross.svg": [
		57061,
		57061
	],
	"./light/crosshairs.svg": [
		60371,
		60371
	],
	"./light/crow.svg": [
		9897,
		9897
	],
	"./light/crown.svg": [
		7456,
		7456
	],
	"./light/crutch.svg": [
		94082,
		94082
	],
	"./light/crutches.svg": [
		21324,
		21324
	],
	"./light/cube.svg": [
		27421,
		27421
	],
	"./light/cubes.svg": [
		64594,
		64594
	],
	"./light/curling.svg": [
		47384,
		47384
	],
	"./light/cut.svg": [
		72147,
		72147
	],
	"./light/dagger.svg": [
		46975,
		46975
	],
	"./light/database.svg": [
		99045,
		99045
	],
	"./light/deaf.svg": [
		95862,
		95862
	],
	"./light/debug.svg": [
		70608,
		70608
	],
	"./light/deer-rudolph.svg": [
		7919,
		7919
	],
	"./light/deer.svg": [
		52727,
		52727
	],
	"./light/democrat.svg": [
		39479,
		39479
	],
	"./light/desktop-alt.svg": [
		70324,
		70324
	],
	"./light/desktop.svg": [
		87364,
		87364
	],
	"./light/dewpoint.svg": [
		33585,
		33585
	],
	"./light/dharmachakra.svg": [
		39542,
		39542
	],
	"./light/diagnoses.svg": [
		58816,
		58816
	],
	"./light/diamond.svg": [
		56064,
		56064
	],
	"./light/dice-d10.svg": [
		49507,
		49507
	],
	"./light/dice-d12.svg": [
		77454,
		77454
	],
	"./light/dice-d20.svg": [
		27848,
		27848
	],
	"./light/dice-d4.svg": [
		36349,
		36349
	],
	"./light/dice-d6.svg": [
		91908,
		91908
	],
	"./light/dice-d8.svg": [
		72276,
		72276
	],
	"./light/dice-five.svg": [
		24974,
		24974
	],
	"./light/dice-four.svg": [
		71058,
		71058
	],
	"./light/dice-one.svg": [
		19639,
		19639
	],
	"./light/dice-six.svg": [
		75662,
		75662
	],
	"./light/dice-three.svg": [
		38649,
		38649
	],
	"./light/dice-two.svg": [
		52792,
		52792
	],
	"./light/dice.svg": [
		88672,
		88672
	],
	"./light/digging.svg": [
		2835,
		2835
	],
	"./light/digital-tachograph.svg": [
		83476,
		27830
	],
	"./light/diploma.svg": [
		73340,
		73340
	],
	"./light/directions.svg": [
		75098,
		75098
	],
	"./light/disc-drive.svg": [
		16775,
		16775
	],
	"./light/disease.svg": [
		13938,
		13938
	],
	"./light/divide.svg": [
		62422,
		62422
	],
	"./light/dizzy.svg": [
		83408,
		83408
	],
	"./light/dna.svg": [
		55167,
		55167
	],
	"./light/do-not-enter.svg": [
		88547,
		88547
	],
	"./light/dog-leashed.svg": [
		22110,
		22110
	],
	"./light/dog.svg": [
		73112,
		73112
	],
	"./light/dollar-sign.svg": [
		36433,
		36433
	],
	"./light/dolly-empty.svg": [
		36636,
		36636
	],
	"./light/dolly-flatbed-alt.svg": [
		92330,
		92330
	],
	"./light/dolly-flatbed-empty.svg": [
		28288,
		28288
	],
	"./light/dolly-flatbed.svg": [
		59680,
		59680
	],
	"./light/dolly.svg": [
		30218,
		30218
	],
	"./light/donate.svg": [
		60727,
		60727
	],
	"./light/door-closed.svg": [
		27327,
		27327
	],
	"./light/door-open.svg": [
		9826,
		9826
	],
	"./light/dot-circle.svg": [
		40299,
		40299
	],
	"./light/dove.svg": [
		50397,
		50397
	],
	"./light/download.svg": [
		69282,
		69282
	],
	"./light/drafting-compass.svg": [
		33020,
		33020
	],
	"./light/dragon.svg": [
		30864,
		30864
	],
	"./light/draw-circle.svg": [
		50191,
		50191
	],
	"./light/draw-polygon.svg": [
		99903,
		99903
	],
	"./light/draw-square.svg": [
		90026,
		90026
	],
	"./light/dreidel.svg": [
		13821,
		13821
	],
	"./light/drone-alt.svg": [
		6489,
		6489
	],
	"./light/drone.svg": [
		85919,
		85919
	],
	"./light/drum-steelpan.svg": [
		17618,
		17618
	],
	"./light/drum.svg": [
		92756,
		92756
	],
	"./light/drumstick-bite.svg": [
		42227,
		42227
	],
	"./light/drumstick.svg": [
		44138,
		44138
	],
	"./light/dryer-alt.svg": [
		60002,
		60002
	],
	"./light/dryer.svg": [
		43986,
		43986
	],
	"./light/duck.svg": [
		76820,
		76820
	],
	"./light/dumbbell.svg": [
		26922,
		26922
	],
	"./light/dumpster-fire.svg": [
		90318,
		90318
	],
	"./light/dumpster.svg": [
		59616,
		59616
	],
	"./light/dungeon.svg": [
		16010,
		16010
	],
	"./light/ear-muffs.svg": [
		89282,
		89282
	],
	"./light/ear.svg": [
		42993,
		42993
	],
	"./light/eclipse-alt.svg": [
		9764,
		9764
	],
	"./light/eclipse.svg": [
		20225,
		20225
	],
	"./light/edit.svg": [
		31940,
		31940
	],
	"./light/egg-fried.svg": [
		13307,
		13307
	],
	"./light/egg.svg": [
		18653,
		18653
	],
	"./light/eject.svg": [
		53243,
		53243
	],
	"./light/elephant.svg": [
		34064,
		34064
	],
	"./light/ellipsis-h-alt.svg": [
		89809,
		89809
	],
	"./light/ellipsis-h.svg": [
		31542,
		31542
	],
	"./light/ellipsis-v-alt.svg": [
		83549,
		83549
	],
	"./light/ellipsis-v.svg": [
		22905,
		22905
	],
	"./light/empty-set.svg": [
		24509,
		24509
	],
	"./light/engine-warning.svg": [
		43752,
		43752
	],
	"./light/envelope-open-dollar.svg": [
		95868,
		58103
	],
	"./light/envelope-open-text.svg": [
		92163,
		92163
	],
	"./light/envelope-open.svg": [
		69157,
		69157
	],
	"./light/envelope-square.svg": [
		50730,
		50730
	],
	"./light/envelope.svg": [
		68593,
		68593
	],
	"./light/equals.svg": [
		39101,
		39101
	],
	"./light/eraser.svg": [
		84613,
		84613
	],
	"./light/ethernet.svg": [
		44989,
		44989
	],
	"./light/euro-sign.svg": [
		53143,
		53143
	],
	"./light/exchange-alt.svg": [
		93972,
		93972
	],
	"./light/exchange.svg": [
		16666,
		16666
	],
	"./light/exclamation-circle.svg": [
		12922,
		12922
	],
	"./light/exclamation-square.svg": [
		99804,
		99804
	],
	"./light/exclamation-triangle.svg": [
		73903,
		73903
	],
	"./light/exclamation.svg": [
		70252,
		70252
	],
	"./light/expand-alt.svg": [
		68212,
		68212
	],
	"./light/expand-arrows-alt.svg": [
		84009,
		84009
	],
	"./light/expand-arrows.svg": [
		48651,
		48651
	],
	"./light/expand-wide.svg": [
		63528,
		63528
	],
	"./light/expand.svg": [
		79540,
		79540
	],
	"./light/external-link-alt.svg": [
		40015,
		40015
	],
	"./light/external-link-square-alt.svg": [
		74358,
		74358
	],
	"./light/external-link-square.svg": [
		887,
		887
	],
	"./light/external-link.svg": [
		93391,
		93391
	],
	"./light/eye-dropper.svg": [
		12798,
		12798
	],
	"./light/eye-evil.svg": [
		44129,
		44129
	],
	"./light/eye-slash.svg": [
		5256,
		5256
	],
	"./light/eye.svg": [
		47817,
		47817
	],
	"./light/fan-table.svg": [
		30542,
		30542
	],
	"./light/fan.svg": [
		10072,
		10072
	],
	"./light/farm.svg": [
		68693,
		68693
	],
	"./light/fast-backward.svg": [
		85407,
		85407
	],
	"./light/fast-forward.svg": [
		70706,
		70706
	],
	"./light/faucet-drip.svg": [
		36683,
		36683
	],
	"./light/faucet.svg": [
		79393,
		79393
	],
	"./light/fax.svg": [
		19481,
		19481
	],
	"./light/feather-alt.svg": [
		59162,
		59162
	],
	"./light/feather.svg": [
		45184,
		45184
	],
	"./light/female.svg": [
		69154,
		69154
	],
	"./light/field-hockey.svg": [
		33082,
		33082
	],
	"./light/fighter-jet.svg": [
		46871,
		46871
	],
	"./light/file-alt.svg": [
		17572,
		17572
	],
	"./light/file-archive.svg": [
		63685,
		63685
	],
	"./light/file-audio.svg": [
		6660,
		6660
	],
	"./light/file-certificate.svg": [
		10019,
		10019
	],
	"./light/file-chart-line.svg": [
		63844,
		63844
	],
	"./light/file-chart-pie.svg": [
		23140,
		23140
	],
	"./light/file-check.svg": [
		77363,
		77363
	],
	"./light/file-code.svg": [
		29965,
		29965
	],
	"./light/file-contract.svg": [
		28068,
		28068
	],
	"./light/file-csv.svg": [
		95069,
		95069
	],
	"./light/file-download.svg": [
		71704,
		71704
	],
	"./light/file-edit.svg": [
		9678,
		9678
	],
	"./light/file-excel.svg": [
		36316,
		36316
	],
	"./light/file-exclamation.svg": [
		68585,
		68585
	],
	"./light/file-export.svg": [
		55332,
		55332
	],
	"./light/file-image.svg": [
		47998,
		47998
	],
	"./light/file-import.svg": [
		60540,
		60540
	],
	"./light/file-invoice-dollar.svg": [
		38917,
		38917
	],
	"./light/file-invoice.svg": [
		19638,
		19638
	],
	"./light/file-medical-alt.svg": [
		45151,
		45151
	],
	"./light/file-medical.svg": [
		38030,
		38030
	],
	"./light/file-minus.svg": [
		9095,
		9095
	],
	"./light/file-music.svg": [
		46542,
		46542
	],
	"./light/file-pdf.svg": [
		99205,
		99205
	],
	"./light/file-plus.svg": [
		98360,
		98360
	],
	"./light/file-powerpoint.svg": [
		61761,
		61761
	],
	"./light/file-prescription.svg": [
		57748,
		57748
	],
	"./light/file-search.svg": [
		77581,
		77581
	],
	"./light/file-signature.svg": [
		21792,
		21792
	],
	"./light/file-spreadsheet.svg": [
		90340,
		90340
	],
	"./light/file-times.svg": [
		67414,
		67414
	],
	"./light/file-upload.svg": [
		54983,
		54983
	],
	"./light/file-user.svg": [
		9906,
		9906
	],
	"./light/file-video.svg": [
		6177,
		6177
	],
	"./light/file-word.svg": [
		35236,
		35236
	],
	"./light/file.svg": [
		81621,
		81621
	],
	"./light/files-medical.svg": [
		25469,
		25469
	],
	"./light/fill-drip.svg": [
		95871,
		95871
	],
	"./light/fill.svg": [
		27978,
		27978
	],
	"./light/film-alt.svg": [
		49965,
		49965
	],
	"./light/film-canister.svg": [
		4582,
		4582
	],
	"./light/film.svg": [
		7883,
		7883
	],
	"./light/filter.svg": [
		6568,
		6568
	],
	"./light/fingerprint.svg": [
		12181,
		12181
	],
	"./light/fire-alt.svg": [
		24794,
		24794
	],
	"./light/fire-extinguisher.svg": [
		43935,
		43935
	],
	"./light/fire-smoke.svg": [
		91363,
		91363
	],
	"./light/fire.svg": [
		9363,
		9363
	],
	"./light/fireplace.svg": [
		15538,
		15538
	],
	"./light/first-aid.svg": [
		45277,
		45277
	],
	"./light/fish-cooked.svg": [
		4885,
		4885
	],
	"./light/fish.svg": [
		28281,
		28281
	],
	"./light/fist-raised.svg": [
		5062,
		5062
	],
	"./light/flag-alt.svg": [
		63940,
		63940
	],
	"./light/flag-checkered.svg": [
		79877,
		79877
	],
	"./light/flag-usa.svg": [
		4447,
		4447
	],
	"./light/flag.svg": [
		79719,
		79719
	],
	"./light/flame.svg": [
		25876,
		25876
	],
	"./light/flashlight.svg": [
		76228,
		76228
	],
	"./light/flask-poison.svg": [
		82889,
		82889
	],
	"./light/flask-potion.svg": [
		51502,
		51502
	],
	"./light/flask.svg": [
		87661,
		87661
	],
	"./light/flower-daffodil.svg": [
		88664,
		88664
	],
	"./light/flower-tulip.svg": [
		31184,
		31184
	],
	"./light/flower.svg": [
		91302,
		91302
	],
	"./light/flushed.svg": [
		60996,
		60996
	],
	"./light/flute.svg": [
		1204,
		1204
	],
	"./light/flux-capacitor.svg": [
		5658,
		5658
	],
	"./light/fog.svg": [
		41774,
		41774
	],
	"./light/folder-download.svg": [
		5871,
		5871
	],
	"./light/folder-minus.svg": [
		15394,
		15394
	],
	"./light/folder-open.svg": [
		89065,
		89065
	],
	"./light/folder-plus.svg": [
		45040,
		15785
	],
	"./light/folder-times.svg": [
		77573,
		77573
	],
	"./light/folder-tree.svg": [
		9904,
		9904
	],
	"./light/folder-upload.svg": [
		90014,
		90014
	],
	"./light/folder.svg": [
		30059,
		30059
	],
	"./light/folders.svg": [
		38170,
		38170
	],
	"./light/font-awesome-logo-full.svg": [
		38941,
		38941
	],
	"./light/font-case.svg": [
		62690,
		62690
	],
	"./light/font.svg": [
		34169,
		34169
	],
	"./light/football-ball.svg": [
		49028,
		49028
	],
	"./light/football-helmet.svg": [
		5136,
		5136
	],
	"./light/forklift.svg": [
		10700,
		10700
	],
	"./light/forward.svg": [
		66286,
		66286
	],
	"./light/fragile.svg": [
		87691,
		87691
	],
	"./light/french-fries.svg": [
		32690,
		32690
	],
	"./light/frog.svg": [
		97443,
		97443
	],
	"./light/frosty-head.svg": [
		22906,
		22906
	],
	"./light/frown-open.svg": [
		86174,
		90607
	],
	"./light/frown.svg": [
		21680,
		21680
	],
	"./light/function.svg": [
		43241,
		43241
	],
	"./light/funnel-dollar.svg": [
		48930,
		48930
	],
	"./light/futbol.svg": [
		50570,
		50570
	],
	"./light/galaxy.svg": [
		78377,
		78377
	],
	"./light/game-board-alt.svg": [
		21491,
		21491
	],
	"./light/game-board.svg": [
		14537,
		14537
	],
	"./light/game-console-handheld.svg": [
		44752,
		44752
	],
	"./light/gamepad-alt.svg": [
		68853,
		68853
	],
	"./light/gamepad.svg": [
		77079,
		77079
	],
	"./light/garage-car.svg": [
		9259,
		9259
	],
	"./light/garage-open.svg": [
		11613,
		11613
	],
	"./light/garage.svg": [
		70476,
		70476
	],
	"./light/gas-pump-slash.svg": [
		6010,
		6010
	],
	"./light/gas-pump.svg": [
		25609,
		25609
	],
	"./light/gavel.svg": [
		81074,
		81074
	],
	"./light/gem.svg": [
		3996,
		3996
	],
	"./light/genderless.svg": [
		15076,
		15076
	],
	"./light/ghost.svg": [
		84923,
		84923
	],
	"./light/gift-card.svg": [
		27042,
		27042
	],
	"./light/gift.svg": [
		54650,
		54650
	],
	"./light/gifts.svg": [
		37095,
		37095
	],
	"./light/gingerbread-man.svg": [
		70014,
		70014
	],
	"./light/glass-champagne.svg": [
		93138,
		93138
	],
	"./light/glass-cheers.svg": [
		69619,
		69619
	],
	"./light/glass-citrus.svg": [
		77262,
		77262
	],
	"./light/glass-martini-alt.svg": [
		68531,
		68531
	],
	"./light/glass-martini.svg": [
		72593,
		72593
	],
	"./light/glass-whiskey-rocks.svg": [
		95705,
		95705
	],
	"./light/glass-whiskey.svg": [
		67943,
		67943
	],
	"./light/glass.svg": [
		97937,
		97937
	],
	"./light/glasses-alt.svg": [
		71089,
		71089
	],
	"./light/glasses.svg": [
		22128,
		22128
	],
	"./light/globe-africa.svg": [
		87673,
		87673
	],
	"./light/globe-americas.svg": [
		70979,
		70979
	],
	"./light/globe-asia.svg": [
		33071,
		33071
	],
	"./light/globe-europe.svg": [
		83838,
		83838
	],
	"./light/globe-snow.svg": [
		15826,
		15826
	],
	"./light/globe-stand.svg": [
		39660,
		39660
	],
	"./light/globe.svg": [
		50355,
		50355
	],
	"./light/golf-ball.svg": [
		95203,
		95203
	],
	"./light/golf-club.svg": [
		9975,
		9975
	],
	"./light/gopuram.svg": [
		81450,
		81450
	],
	"./light/graduation-cap.svg": [
		64778,
		64778
	],
	"./light/gramophone.svg": [
		80969,
		80969
	],
	"./light/greater-than-equal.svg": [
		65226,
		65226
	],
	"./light/greater-than.svg": [
		80650,
		80650
	],
	"./light/grimace.svg": [
		50241,
		50241
	],
	"./light/grin-alt.svg": [
		50736,
		50736
	],
	"./light/grin-beam-sweat.svg": [
		43625,
		43625
	],
	"./light/grin-beam.svg": [
		10218,
		10218
	],
	"./light/grin-hearts.svg": [
		19446,
		19446
	],
	"./light/grin-squint-tears.svg": [
		46679,
		46679
	],
	"./light/grin-squint.svg": [
		63216,
		63216
	],
	"./light/grin-stars.svg": [
		66317,
		66317
	],
	"./light/grin-tears.svg": [
		7537,
		7537
	],
	"./light/grin-tongue-squint.svg": [
		23806,
		23806
	],
	"./light/grin-tongue-wink.svg": [
		73744,
		73744
	],
	"./light/grin-tongue.svg": [
		31278,
		31278
	],
	"./light/grin-wink.svg": [
		68076,
		68076
	],
	"./light/grin.svg": [
		13756,
		13756
	],
	"./light/grip-horizontal.svg": [
		34030,
		34030
	],
	"./light/grip-lines-vertical.svg": [
		53439,
		53439
	],
	"./light/grip-lines.svg": [
		81660,
		81660
	],
	"./light/grip-vertical.svg": [
		76319,
		76319
	],
	"./light/guitar-electric.svg": [
		24391,
		24391
	],
	"./light/guitar.svg": [
		66866,
		66866
	],
	"./light/guitars.svg": [
		88014,
		88014
	],
	"./light/h-square.svg": [
		19078,
		19078
	],
	"./light/h1.svg": [
		79168,
		79168
	],
	"./light/h2.svg": [
		83066,
		83066
	],
	"./light/h3.svg": [
		918,
		918
	],
	"./light/h4.svg": [
		61190,
		61190
	],
	"./light/hamburger.svg": [
		70379,
		70379
	],
	"./light/hammer-war.svg": [
		14272,
		14272
	],
	"./light/hammer.svg": [
		83938,
		83938
	],
	"./light/hamsa.svg": [
		6770,
		6770
	],
	"./light/hand-heart.svg": [
		57978,
		57978
	],
	"./light/hand-holding-box.svg": [
		28136,
		28136
	],
	"./light/hand-holding-heart.svg": [
		54708,
		54708
	],
	"./light/hand-holding-magic.svg": [
		36096,
		36096
	],
	"./light/hand-holding-medical.svg": [
		10127,
		10127
	],
	"./light/hand-holding-seedling.svg": [
		17190,
		17190
	],
	"./light/hand-holding-usd.svg": [
		21175,
		21175
	],
	"./light/hand-holding-water.svg": [
		96419,
		96419
	],
	"./light/hand-holding.svg": [
		15460,
		15460
	],
	"./light/hand-lizard.svg": [
		94914,
		94914
	],
	"./light/hand-middle-finger.svg": [
		22722,
		22722
	],
	"./light/hand-paper.svg": [
		72464,
		72464
	],
	"./light/hand-peace.svg": [
		7708,
		7708
	],
	"./light/hand-point-down.svg": [
		29260,
		29260
	],
	"./light/hand-point-left.svg": [
		21677,
		21677
	],
	"./light/hand-point-right.svg": [
		31579,
		31579
	],
	"./light/hand-point-up.svg": [
		91377,
		91377
	],
	"./light/hand-pointer.svg": [
		13316,
		13316
	],
	"./light/hand-receiving.svg": [
		13277,
		13277
	],
	"./light/hand-rock.svg": [
		58441,
		58441
	],
	"./light/hand-scissors.svg": [
		50285,
		50285
	],
	"./light/hand-sparkles.svg": [
		30895,
		30895
	],
	"./light/hand-spock.svg": [
		54206,
		54206
	],
	"./light/hands-heart.svg": [
		78137,
		78137
	],
	"./light/hands-helping.svg": [
		55413,
		55413
	],
	"./light/hands-usd.svg": [
		88375,
		88375
	],
	"./light/hands-wash.svg": [
		80169,
		80169
	],
	"./light/hands.svg": [
		45755,
		45755
	],
	"./light/handshake-alt-slash.svg": [
		11182,
		11182
	],
	"./light/handshake-alt.svg": [
		11560,
		11560
	],
	"./light/handshake-slash.svg": [
		14762,
		14762
	],
	"./light/handshake.svg": [
		62274,
		62274
	],
	"./light/hanukiah.svg": [
		32841,
		32841
	],
	"./light/hard-hat.svg": [
		25352,
		25352
	],
	"./light/hashtag.svg": [
		82838,
		82838
	],
	"./light/hat-chef.svg": [
		86464,
		86464
	],
	"./light/hat-cowboy-side.svg": [
		38839,
		38839
	],
	"./light/hat-cowboy.svg": [
		88528,
		88528
	],
	"./light/hat-santa.svg": [
		69448,
		69448
	],
	"./light/hat-winter.svg": [
		4033,
		4033
	],
	"./light/hat-witch.svg": [
		7280,
		7280
	],
	"./light/hat-wizard.svg": [
		19883,
		19883
	],
	"./light/hdd.svg": [
		99789,
		99789
	],
	"./light/head-side-brain.svg": [
		28614,
		28614
	],
	"./light/head-side-cough-slash.svg": [
		88839,
		88839
	],
	"./light/head-side-cough.svg": [
		32218,
		32218
	],
	"./light/head-side-headphones.svg": [
		46889,
		46889
	],
	"./light/head-side-mask.svg": [
		98198,
		98198
	],
	"./light/head-side-medical.svg": [
		78772,
		78772
	],
	"./light/head-side-virus.svg": [
		95576,
		95576
	],
	"./light/head-side.svg": [
		49156,
		49156
	],
	"./light/head-vr.svg": [
		39825,
		39825
	],
	"./light/heading.svg": [
		78214,
		78214
	],
	"./light/headphones-alt.svg": [
		41310,
		41310
	],
	"./light/headphones.svg": [
		37527,
		37527
	],
	"./light/headset.svg": [
		55449,
		55449
	],
	"./light/heart-broken.svg": [
		17015,
		17015
	],
	"./light/heart-circle.svg": [
		2179,
		2179
	],
	"./light/heart-rate.svg": [
		38162,
		38162
	],
	"./light/heart-square.svg": [
		14817,
		14817
	],
	"./light/heart.svg": [
		26964,
		26964
	],
	"./light/heartbeat.svg": [
		31739,
		31739
	],
	"./light/heat.svg": [
		12618,
		12618
	],
	"./light/helicopter.svg": [
		57907,
		57907
	],
	"./light/helmet-battle.svg": [
		9994,
		9994
	],
	"./light/hexagon.svg": [
		84606,
		84606
	],
	"./light/highlighter.svg": [
		10076,
		10076
	],
	"./light/hiking.svg": [
		81675,
		81675
	],
	"./light/hippo.svg": [
		3099,
		3099
	],
	"./light/history.svg": [
		54605,
		54605
	],
	"./light/hockey-mask.svg": [
		16338,
		16338
	],
	"./light/hockey-puck.svg": [
		79866,
		79866
	],
	"./light/hockey-sticks.svg": [
		62484,
		62484
	],
	"./light/holly-berry.svg": [
		24681,
		24681
	],
	"./light/home-alt.svg": [
		40837,
		40837
	],
	"./light/home-heart.svg": [
		48500,
		48500
	],
	"./light/home-lg-alt.svg": [
		98752,
		98752
	],
	"./light/home-lg.svg": [
		93729,
		93729
	],
	"./light/home.svg": [
		80675,
		80675
	],
	"./light/hood-cloak.svg": [
		39854,
		39854
	],
	"./light/horizontal-rule.svg": [
		80923,
		80923
	],
	"./light/horse-head.svg": [
		96478,
		96478
	],
	"./light/horse-saddle.svg": [
		47775,
		47775
	],
	"./light/horse.svg": [
		76886,
		76886
	],
	"./light/hospital-alt.svg": [
		42860,
		42860
	],
	"./light/hospital-symbol.svg": [
		53666,
		53666
	],
	"./light/hospital-user.svg": [
		20994,
		20994
	],
	"./light/hospital.svg": [
		611,
		611
	],
	"./light/hospitals.svg": [
		52162,
		52162
	],
	"./light/hot-tub.svg": [
		63439,
		63439
	],
	"./light/hotdog.svg": [
		48421,
		48421
	],
	"./light/hotel.svg": [
		1874,
		1874
	],
	"./light/hourglass-end.svg": [
		6648,
		6648
	],
	"./light/hourglass-half.svg": [
		65217,
		65217
	],
	"./light/hourglass-start.svg": [
		83520,
		83520
	],
	"./light/hourglass.svg": [
		64984,
		64984
	],
	"./light/house-damage.svg": [
		13530,
		13530
	],
	"./light/house-day.svg": [
		22721,
		22721
	],
	"./light/house-flood.svg": [
		10794,
		10794
	],
	"./light/house-leave.svg": [
		72604,
		72604
	],
	"./light/house-night.svg": [
		92839,
		92839
	],
	"./light/house-return.svg": [
		79917,
		79917
	],
	"./light/house-signal.svg": [
		91763,
		91763
	],
	"./light/house-user.svg": [
		16850,
		16850
	],
	"./light/house.svg": [
		58990,
		58990
	],
	"./light/hryvnia.svg": [
		44029,
		44029
	],
	"./light/humidity.svg": [
		98531,
		98531
	],
	"./light/hurricane.svg": [
		11302,
		11302
	],
	"./light/i-cursor.svg": [
		56118,
		56118
	],
	"./light/ice-cream.svg": [
		91852,
		91852
	],
	"./light/ice-skate.svg": [
		40834,
		40834
	],
	"./light/icicles.svg": [
		82408,
		82408
	],
	"./light/icons-alt.svg": [
		10781,
		10781
	],
	"./light/icons.svg": [
		24515,
		24515
	],
	"./light/id-badge.svg": [
		5002,
		5002
	],
	"./light/id-card-alt.svg": [
		24205,
		24205
	],
	"./light/id-card.svg": [
		86330,
		86330
	],
	"./light/igloo.svg": [
		37053,
		37053
	],
	"./light/image-polaroid.svg": [
		59280,
		59280
	],
	"./light/image.svg": [
		76620,
		76620
	],
	"./light/images.svg": [
		56765,
		56765
	],
	"./light/inbox-in.svg": [
		6802,
		6802
	],
	"./light/inbox-out.svg": [
		9120,
		9120
	],
	"./light/inbox.svg": [
		64214,
		64214
	],
	"./light/indent.svg": [
		11089,
		11089
	],
	"./light/industry-alt.svg": [
		22167,
		22167
	],
	"./light/industry.svg": [
		13381,
		13381
	],
	"./light/infinity.svg": [
		78126,
		78126
	],
	"./light/info-circle.svg": [
		77609,
		77609
	],
	"./light/info-square.svg": [
		16535,
		16535
	],
	"./light/info.svg": [
		90344,
		90344
	],
	"./light/inhaler.svg": [
		96522,
		96522
	],
	"./light/integral.svg": [
		92109,
		92109
	],
	"./light/intersection.svg": [
		20960,
		20960
	],
	"./light/inventory.svg": [
		92358,
		92358
	],
	"./light/island-tropical.svg": [
		52529,
		52529
	],
	"./light/italic.svg": [
		78081,
		78081
	],
	"./light/jack-o-lantern.svg": [
		66303,
		66303
	],
	"./light/jedi.svg": [
		75130,
		75130
	],
	"./light/joint.svg": [
		59706,
		59706
	],
	"./light/journal-whills.svg": [
		50837,
		50837
	],
	"./light/joystick.svg": [
		5099,
		5099
	],
	"./light/jug.svg": [
		40111,
		40111
	],
	"./light/kaaba.svg": [
		55517,
		55517
	],
	"./light/kazoo.svg": [
		5473,
		5473
	],
	"./light/kerning.svg": [
		87920,
		87920
	],
	"./light/key-skeleton.svg": [
		4396,
		4396
	],
	"./light/key.svg": [
		41600,
		41600
	],
	"./light/keyboard.svg": [
		34032,
		34032
	],
	"./light/keynote.svg": [
		78440,
		78440
	],
	"./light/khanda.svg": [
		93617,
		93617
	],
	"./light/kidneys.svg": [
		30332,
		30332
	],
	"./light/kiss-beam.svg": [
		50284,
		50284
	],
	"./light/kiss-wink-heart.svg": [
		42131,
		42131
	],
	"./light/kiss.svg": [
		99204,
		99204
	],
	"./light/kite.svg": [
		43173,
		43173
	],
	"./light/kiwi-bird.svg": [
		24801,
		24801
	],
	"./light/knife-kitchen.svg": [
		86398,
		86398
	],
	"./light/lambda.svg": [
		51045,
		51045
	],
	"./light/lamp-desk.svg": [
		57098,
		57098
	],
	"./light/lamp-floor.svg": [
		16859,
		16859
	],
	"./light/lamp.svg": [
		68486,
		68486
	],
	"./light/landmark-alt.svg": [
		21985,
		21985
	],
	"./light/landmark.svg": [
		89398,
		89398
	],
	"./light/language.svg": [
		6889,
		6889
	],
	"./light/laptop-code.svg": [
		61786,
		61786
	],
	"./light/laptop-house.svg": [
		93008,
		93008
	],
	"./light/laptop-medical.svg": [
		32561,
		32561
	],
	"./light/laptop.svg": [
		12287,
		12287
	],
	"./light/lasso.svg": [
		41010,
		87985
	],
	"./light/laugh-beam.svg": [
		62953,
		62953
	],
	"./light/laugh-squint.svg": [
		96955,
		96955
	],
	"./light/laugh-wink.svg": [
		29850,
		29850
	],
	"./light/laugh.svg": [
		4414,
		4414
	],
	"./light/layer-group.svg": [
		32805,
		32805
	],
	"./light/layer-minus.svg": [
		47178,
		47178
	],
	"./light/layer-plus.svg": [
		22511,
		22511
	],
	"./light/leaf-heart.svg": [
		92334,
		92334
	],
	"./light/leaf-maple.svg": [
		51794,
		51794
	],
	"./light/leaf-oak.svg": [
		20579,
		20579
	],
	"./light/leaf.svg": [
		8165,
		8165
	],
	"./light/lemon.svg": [
		2223,
		2223
	],
	"./light/less-than-equal.svg": [
		87273,
		91564
	],
	"./light/less-than.svg": [
		44332,
		44332
	],
	"./light/level-down-alt.svg": [
		12334,
		12334
	],
	"./light/level-down.svg": [
		5060,
		5060
	],
	"./light/level-up-alt.svg": [
		44036,
		86174
	],
	"./light/level-up.svg": [
		8321,
		8321
	],
	"./light/life-ring.svg": [
		52925,
		52925
	],
	"./light/light-ceiling.svg": [
		86902,
		86902
	],
	"./light/light-switch-off.svg": [
		89619,
		89619
	],
	"./light/light-switch-on.svg": [
		92929,
		92929
	],
	"./light/light-switch.svg": [
		695,
		695
	],
	"./light/lightbulb-dollar.svg": [
		78995,
		78995
	],
	"./light/lightbulb-exclamation.svg": [
		54147,
		82922
	],
	"./light/lightbulb-on.svg": [
		65463,
		65463
	],
	"./light/lightbulb-slash.svg": [
		12703,
		12703
	],
	"./light/lightbulb.svg": [
		70928,
		70928
	],
	"./light/lights-holiday.svg": [
		52193,
		52193
	],
	"./light/line-columns.svg": [
		50422,
		50422
	],
	"./light/line-height.svg": [
		7490,
		7490
	],
	"./light/link.svg": [
		95260,
		95260
	],
	"./light/lips.svg": [
		51050,
		51050
	],
	"./light/lira-sign.svg": [
		7666,
		7666
	],
	"./light/list-alt.svg": [
		96493,
		96493
	],
	"./light/list-music.svg": [
		44869,
		44869
	],
	"./light/list-ol.svg": [
		99737,
		99737
	],
	"./light/list-ul.svg": [
		36048,
		36048
	],
	"./light/list.svg": [
		7912,
		7912
	],
	"./light/location-arrow.svg": [
		35332,
		35332
	],
	"./light/location-circle.svg": [
		91149,
		91149
	],
	"./light/location-slash.svg": [
		14209,
		14209
	],
	"./light/location.svg": [
		72877,
		72877
	],
	"./light/lock-alt.svg": [
		28459,
		28459
	],
	"./light/lock-open-alt.svg": [
		7523,
		7523
	],
	"./light/lock-open.svg": [
		7971,
		7971
	],
	"./light/lock.svg": [
		99565,
		99565
	],
	"./light/long-arrow-alt-down.svg": [
		36802,
		36802
	],
	"./light/long-arrow-alt-left.svg": [
		16950,
		16950
	],
	"./light/long-arrow-alt-right.svg": [
		39745,
		39745
	],
	"./light/long-arrow-alt-up.svg": [
		13562,
		13562
	],
	"./light/long-arrow-down.svg": [
		38559,
		87273
	],
	"./light/long-arrow-left.svg": [
		82948,
		82948
	],
	"./light/long-arrow-right.svg": [
		90294,
		90294
	],
	"./light/long-arrow-up.svg": [
		34938,
		34938
	],
	"./light/loveseat.svg": [
		16000,
		16000
	],
	"./light/low-vision.svg": [
		16456,
		16456
	],
	"./light/luchador.svg": [
		11452,
		11452
	],
	"./light/luggage-cart.svg": [
		97256,
		97256
	],
	"./light/lungs-virus.svg": [
		82646,
		82646
	],
	"./light/lungs.svg": [
		47466,
		47466
	],
	"./light/mace.svg": [
		83916,
		83916
	],
	"./light/magic.svg": [
		81073,
		81073
	],
	"./light/magnet.svg": [
		93796,
		93796
	],
	"./light/mail-bulk.svg": [
		6401,
		6401
	],
	"./light/mailbox.svg": [
		82212,
		82212
	],
	"./light/male.svg": [
		64371,
		64371
	],
	"./light/mandolin.svg": [
		98382,
		98382
	],
	"./light/map-marked-alt.svg": [
		70133,
		70133
	],
	"./light/map-marked.svg": [
		62009,
		62009
	],
	"./light/map-marker-alt-slash.svg": [
		12345,
		12345
	],
	"./light/map-marker-alt.svg": [
		65295,
		65295
	],
	"./light/map-marker-check.svg": [
		66094,
		66094
	],
	"./light/map-marker-edit.svg": [
		7936,
		7936
	],
	"./light/map-marker-exclamation.svg": [
		1704,
		1704
	],
	"./light/map-marker-minus.svg": [
		70682,
		70682
	],
	"./light/map-marker-plus.svg": [
		97637,
		97637
	],
	"./light/map-marker-question.svg": [
		82315,
		82315
	],
	"./light/map-marker-slash.svg": [
		54627,
		54627
	],
	"./light/map-marker-smile.svg": [
		75848,
		75848
	],
	"./light/map-marker-times.svg": [
		43341,
		43341
	],
	"./light/map-marker.svg": [
		76781,
		76781
	],
	"./light/map-pin.svg": [
		14682,
		14682
	],
	"./light/map-signs.svg": [
		74549,
		74549
	],
	"./light/map.svg": [
		54796,
		54796
	],
	"./light/marker.svg": [
		23793,
		23793
	],
	"./light/mars-double.svg": [
		39623,
		39623
	],
	"./light/mars-stroke-h.svg": [
		67888,
		67888
	],
	"./light/mars-stroke-v.svg": [
		23953,
		23953
	],
	"./light/mars-stroke.svg": [
		62692,
		62692
	],
	"./light/mars.svg": [
		55881,
		55881
	],
	"./light/mask.svg": [
		95480,
		95480
	],
	"./light/meat.svg": [
		67553,
		67553
	],
	"./light/medal.svg": [
		25656,
		25656
	],
	"./light/medkit.svg": [
		68186,
		68186
	],
	"./light/megaphone.svg": [
		50786,
		50786
	],
	"./light/meh-blank.svg": [
		30054,
		30054
	],
	"./light/meh-rolling-eyes.svg": [
		54508,
		54508
	],
	"./light/meh.svg": [
		63511,
		63511
	],
	"./light/memory.svg": [
		94868,
		94868
	],
	"./light/menorah.svg": [
		7142,
		7142
	],
	"./light/mercury.svg": [
		48202,
		48202
	],
	"./light/meteor.svg": [
		29048,
		29048
	],
	"./light/microchip.svg": [
		50227,
		50227
	],
	"./light/microphone-alt-slash.svg": [
		90912,
		90912
	],
	"./light/microphone-alt.svg": [
		58381,
		58381
	],
	"./light/microphone-slash.svg": [
		53963,
		53963
	],
	"./light/microphone-stand.svg": [
		80805,
		80805
	],
	"./light/microphone.svg": [
		96953,
		96953
	],
	"./light/microscope.svg": [
		61805,
		61805
	],
	"./light/microwave.svg": [
		71649,
		71649
	],
	"./light/mind-share.svg": [
		29243,
		29243
	],
	"./light/minus-circle.svg": [
		85563,
		85563
	],
	"./light/minus-hexagon.svg": [
		38312,
		38312
	],
	"./light/minus-octagon.svg": [
		75248,
		75248
	],
	"./light/minus-square.svg": [
		98889,
		98889
	],
	"./light/minus.svg": [
		29829,
		29829
	],
	"./light/mistletoe.svg": [
		55955,
		55955
	],
	"./light/mitten.svg": [
		85668,
		85668
	],
	"./light/mobile-alt.svg": [
		41846,
		41846
	],
	"./light/mobile-android-alt.svg": [
		32370,
		32370
	],
	"./light/mobile-android.svg": [
		29579,
		29579
	],
	"./light/mobile.svg": [
		49340,
		49340
	],
	"./light/money-bill-alt.svg": [
		16118,
		16118
	],
	"./light/money-bill-wave-alt.svg": [
		28392,
		28392
	],
	"./light/money-bill-wave.svg": [
		98497,
		98497
	],
	"./light/money-bill.svg": [
		38982,
		38982
	],
	"./light/money-check-alt.svg": [
		11073,
		11073
	],
	"./light/money-check-edit-alt.svg": [
		43487,
		43487
	],
	"./light/money-check-edit.svg": [
		70763,
		70763
	],
	"./light/money-check.svg": [
		37914,
		37914
	],
	"./light/monitor-heart-rate.svg": [
		20336,
		20336
	],
	"./light/monkey.svg": [
		62745,
		62745
	],
	"./light/monument.svg": [
		60525,
		60525
	],
	"./light/moon-cloud.svg": [
		10280,
		10280
	],
	"./light/moon-stars.svg": [
		53822,
		41792
	],
	"./light/moon.svg": [
		80664,
		80664
	],
	"./light/mortar-pestle.svg": [
		64567,
		64567
	],
	"./light/mosque.svg": [
		43963,
		43963
	],
	"./light/motorcycle.svg": [
		61728,
		61728
	],
	"./light/mountain.svg": [
		22228,
		22228
	],
	"./light/mountains.svg": [
		81700,
		81700
	],
	"./light/mouse-alt.svg": [
		20100,
		20100
	],
	"./light/mouse-pointer.svg": [
		5285,
		5285
	],
	"./light/mouse.svg": [
		29459,
		29459
	],
	"./light/mp3-player.svg": [
		4923,
		4923
	],
	"./light/mug-hot.svg": [
		36302,
		36302
	],
	"./light/mug-marshmallows.svg": [
		39600,
		39600
	],
	"./light/mug-tea.svg": [
		13976,
		62684
	],
	"./light/mug.svg": [
		56101,
		56101
	],
	"./light/music-alt-slash.svg": [
		68696,
		68696
	],
	"./light/music-alt.svg": [
		84397,
		84397
	],
	"./light/music-slash.svg": [
		52588,
		52588
	],
	"./light/music.svg": [
		29811,
		29811
	],
	"./light/narwhal.svg": [
		29055,
		29055
	],
	"./light/network-wired.svg": [
		17605,
		17605
	],
	"./light/neuter.svg": [
		31271,
		31271
	],
	"./light/newspaper.svg": [
		42561,
		42561
	],
	"./light/not-equal.svg": [
		35668,
		35668
	],
	"./light/notes-medical.svg": [
		46181,
		46181
	],
	"./light/object-group.svg": [
		76573,
		76573
	],
	"./light/object-ungroup.svg": [
		98627,
		98627
	],
	"./light/octagon.svg": [
		14602,
		14602
	],
	"./light/oil-can.svg": [
		97024,
		97024
	],
	"./light/oil-temp.svg": [
		63807,
		63807
	],
	"./light/om.svg": [
		76492,
		76492
	],
	"./light/omega.svg": [
		93908,
		93908
	],
	"./light/ornament.svg": [
		20853,
		20853
	],
	"./light/otter.svg": [
		61133,
		61133
	],
	"./light/outdent.svg": [
		29830,
		53386
	],
	"./light/outlet.svg": [
		68290,
		68290
	],
	"./light/oven.svg": [
		51327,
		51327
	],
	"./light/overline.svg": [
		84743,
		84743
	],
	"./light/page-break.svg": [
		78484,
		78484
	],
	"./light/pager.svg": [
		53909,
		53909
	],
	"./light/paint-brush-alt.svg": [
		61880,
		61880
	],
	"./light/paint-brush.svg": [
		13885,
		13885
	],
	"./light/paint-roller.svg": [
		44748,
		44748
	],
	"./light/palette.svg": [
		84772,
		84772
	],
	"./light/pallet-alt.svg": [
		42839,
		42839
	],
	"./light/pallet.svg": [
		41508,
		41508
	],
	"./light/paper-plane.svg": [
		7946,
		7946
	],
	"./light/paperclip.svg": [
		69403,
		69403
	],
	"./light/parachute-box.svg": [
		52412,
		52412
	],
	"./light/paragraph-rtl.svg": [
		27886,
		27886
	],
	"./light/paragraph.svg": [
		83615,
		83615
	],
	"./light/parking-circle-slash.svg": [
		19390,
		19390
	],
	"./light/parking-circle.svg": [
		78978,
		78978
	],
	"./light/parking-slash.svg": [
		56266,
		56266
	],
	"./light/parking.svg": [
		70219,
		70219
	],
	"./light/passport.svg": [
		16688,
		16688
	],
	"./light/pastafarianism.svg": [
		78375,
		78375
	],
	"./light/paste.svg": [
		85773,
		85773
	],
	"./light/pause-circle.svg": [
		60949,
		60949
	],
	"./light/pause.svg": [
		45435,
		45435
	],
	"./light/paw-alt.svg": [
		30881,
		30881
	],
	"./light/paw-claws.svg": [
		954,
		954
	],
	"./light/paw.svg": [
		26572,
		26572
	],
	"./light/peace.svg": [
		46798,
		46798
	],
	"./light/pegasus.svg": [
		29854,
		29854
	],
	"./light/pen-alt.svg": [
		64277,
		64277
	],
	"./light/pen-fancy.svg": [
		41091,
		41091
	],
	"./light/pen-nib.svg": [
		65121,
		65121
	],
	"./light/pen-square.svg": [
		44165,
		44165
	],
	"./light/pen.svg": [
		54173,
		54173
	],
	"./light/pencil-alt.svg": [
		38489,
		38489
	],
	"./light/pencil-paintbrush.svg": [
		90232,
		90232
	],
	"./light/pencil-ruler.svg": [
		65531,
		65531
	],
	"./light/pencil.svg": [
		81915,
		81915
	],
	"./light/pennant.svg": [
		87692,
		87692
	],
	"./light/people-arrows.svg": [
		20755,
		20755
	],
	"./light/people-carry.svg": [
		32629,
		32629
	],
	"./light/pepper-hot.svg": [
		94036,
		94036
	],
	"./light/percent.svg": [
		1256,
		1256
	],
	"./light/percentage.svg": [
		51507,
		51507
	],
	"./light/person-booth.svg": [
		45176,
		45176
	],
	"./light/person-carry.svg": [
		94148,
		94148
	],
	"./light/person-dolly-empty.svg": [
		81474,
		81474
	],
	"./light/person-dolly.svg": [
		70394,
		70394
	],
	"./light/person-sign.svg": [
		90207,
		90207
	],
	"./light/phone-alt.svg": [
		91962,
		91962
	],
	"./light/phone-laptop.svg": [
		77350,
		77350
	],
	"./light/phone-office.svg": [
		58881,
		58881
	],
	"./light/phone-plus.svg": [
		59177,
		59177
	],
	"./light/phone-rotary.svg": [
		93553,
		93553
	],
	"./light/phone-slash.svg": [
		64174,
		64174
	],
	"./light/phone-square-alt.svg": [
		49959,
		49959
	],
	"./light/phone-square.svg": [
		71182,
		71182
	],
	"./light/phone-volume.svg": [
		95255,
		95255
	],
	"./light/phone.svg": [
		17235,
		17235
	],
	"./light/photo-video.svg": [
		84340,
		84340
	],
	"./light/pi.svg": [
		42257,
		42257
	],
	"./light/piano-keyboard.svg": [
		55110,
		55110
	],
	"./light/piano.svg": [
		26674,
		26674
	],
	"./light/pie.svg": [
		52404,
		52404
	],
	"./light/pig.svg": [
		25916,
		25916
	],
	"./light/piggy-bank.svg": [
		20499,
		20499
	],
	"./light/pills.svg": [
		14245,
		14245
	],
	"./light/pizza-slice.svg": [
		27607,
		27607
	],
	"./light/pizza.svg": [
		74042,
		74042
	],
	"./light/place-of-worship.svg": [
		5313,
		5313
	],
	"./light/plane-alt.svg": [
		77379,
		77379
	],
	"./light/plane-arrival.svg": [
		31851,
		31851
	],
	"./light/plane-departure.svg": [
		84358,
		84358
	],
	"./light/plane-slash.svg": [
		83621,
		83621
	],
	"./light/plane.svg": [
		30221,
		53822
	],
	"./light/planet-moon.svg": [
		99334,
		99334
	],
	"./light/planet-ringed.svg": [
		36258,
		36258
	],
	"./light/play-circle.svg": [
		71642,
		71642
	],
	"./light/play.svg": [
		50468,
		50468
	],
	"./light/plug.svg": [
		2515,
		2515
	],
	"./light/plus-circle.svg": [
		49793,
		49793
	],
	"./light/plus-hexagon.svg": [
		77485,
		77485
	],
	"./light/plus-octagon.svg": [
		97571,
		97571
	],
	"./light/plus-square.svg": [
		37176,
		37176
	],
	"./light/plus.svg": [
		24869,
		24869
	],
	"./light/podcast.svg": [
		6734,
		6734
	],
	"./light/podium-star.svg": [
		53304,
		53304
	],
	"./light/podium.svg": [
		8331,
		8331
	],
	"./light/police-box.svg": [
		51613,
		51613
	],
	"./light/poll-h.svg": [
		92414,
		92414
	],
	"./light/poll-people.svg": [
		3562,
		3562
	],
	"./light/poll.svg": [
		38591,
		38591
	],
	"./light/poo-storm.svg": [
		39696,
		39696
	],
	"./light/poo.svg": [
		47370,
		47370
	],
	"./light/poop.svg": [
		46902,
		46902
	],
	"./light/popcorn.svg": [
		60408,
		60408
	],
	"./light/portal-enter.svg": [
		52089,
		52089
	],
	"./light/portal-exit.svg": [
		89590,
		89590
	],
	"./light/portrait.svg": [
		60687,
		60687
	],
	"./light/pound-sign.svg": [
		75284,
		75284
	],
	"./light/power-off.svg": [
		17157,
		17157
	],
	"./light/pray.svg": [
		64477,
		64477
	],
	"./light/praying-hands.svg": [
		30942,
		30942
	],
	"./light/prescription-bottle-alt.svg": [
		35988,
		35988
	],
	"./light/prescription-bottle.svg": [
		90200,
		90200
	],
	"./light/prescription.svg": [
		28301,
		28301
	],
	"./light/presentation.svg": [
		15220,
		15220
	],
	"./light/print-search.svg": [
		46690,
		46690
	],
	"./light/print-slash.svg": [
		79440,
		79440
	],
	"./light/print.svg": [
		54255,
		54255
	],
	"./light/procedures.svg": [
		53976,
		53976
	],
	"./light/project-diagram.svg": [
		71854,
		71854
	],
	"./light/projector.svg": [
		27746,
		27746
	],
	"./light/pump-medical.svg": [
		77603,
		77603
	],
	"./light/pump-soap.svg": [
		3820,
		3820
	],
	"./light/pumpkin.svg": [
		1665,
		1665
	],
	"./light/puzzle-piece.svg": [
		1043,
		1043
	],
	"./light/qrcode.svg": [
		16047,
		16047
	],
	"./light/question-circle.svg": [
		8294,
		8294
	],
	"./light/question-square.svg": [
		31536,
		31536
	],
	"./light/question.svg": [
		30794,
		30794
	],
	"./light/quidditch.svg": [
		11465,
		11465
	],
	"./light/quote-left.svg": [
		55034,
		55034
	],
	"./light/quote-right.svg": [
		13683,
		13683
	],
	"./light/quran.svg": [
		18637,
		18637
	],
	"./light/rabbit-fast.svg": [
		59126,
		59126
	],
	"./light/rabbit.svg": [
		39417,
		39417
	],
	"./light/racquet.svg": [
		5870,
		5870
	],
	"./light/radar.svg": [
		74381,
		74381
	],
	"./light/radiation-alt.svg": [
		98796,
		98796
	],
	"./light/radiation.svg": [
		9196,
		9196
	],
	"./light/radio-alt.svg": [
		16692,
		16692
	],
	"./light/radio.svg": [
		95553,
		95553
	],
	"./light/rainbow.svg": [
		70047,
		70047
	],
	"./light/raindrops.svg": [
		44213,
		44213
	],
	"./light/ram.svg": [
		55285,
		55285
	],
	"./light/ramp-loading.svg": [
		92427,
		92427
	],
	"./light/random.svg": [
		41411,
		41411
	],
	"./light/raygun.svg": [
		53572,
		53572
	],
	"./light/receipt.svg": [
		72831,
		72831
	],
	"./light/record-vinyl.svg": [
		78589,
		78589
	],
	"./light/rectangle-landscape.svg": [
		92000,
		92000
	],
	"./light/rectangle-portrait.svg": [
		78789,
		78789
	],
	"./light/rectangle-wide.svg": [
		40906,
		40906
	],
	"./light/recycle.svg": [
		71050,
		71050
	],
	"./light/redo-alt.svg": [
		63570,
		63570
	],
	"./light/redo.svg": [
		90991,
		90991
	],
	"./light/refrigerator.svg": [
		61030,
		61030
	],
	"./light/registered.svg": [
		67349,
		67349
	],
	"./light/remove-format.svg": [
		55284,
		55284
	],
	"./light/repeat-1-alt.svg": [
		17705,
		17705
	],
	"./light/repeat-1.svg": [
		70916,
		70916
	],
	"./light/repeat-alt.svg": [
		94345,
		94345
	],
	"./light/repeat.svg": [
		79179,
		79179
	],
	"./light/reply-all.svg": [
		39241,
		39241
	],
	"./light/reply.svg": [
		82678,
		82678
	],
	"./light/republican.svg": [
		99262,
		99262
	],
	"./light/restroom.svg": [
		11278,
		11278
	],
	"./light/retweet-alt.svg": [
		9952,
		9952
	],
	"./light/retweet.svg": [
		49915,
		49915
	],
	"./light/ribbon.svg": [
		10310,
		10310
	],
	"./light/ring.svg": [
		92446,
		92446
	],
	"./light/rings-wedding.svg": [
		2144,
		2144
	],
	"./light/road.svg": [
		59117,
		59117
	],
	"./light/robot.svg": [
		60347,
		60347
	],
	"./light/rocket-launch.svg": [
		29107,
		29107
	],
	"./light/rocket.svg": [
		37118,
		37118
	],
	"./light/route-highway.svg": [
		14804,
		14804
	],
	"./light/route-interstate.svg": [
		27684,
		27684
	],
	"./light/route.svg": [
		15017,
		15017
	],
	"./light/router.svg": [
		19130,
		19130
	],
	"./light/rss-square.svg": [
		15836,
		15836
	],
	"./light/rss.svg": [
		18489,
		18489
	],
	"./light/ruble-sign.svg": [
		22920,
		22920
	],
	"./light/ruler-combined.svg": [
		16975,
		16975
	],
	"./light/ruler-horizontal.svg": [
		39445,
		39445
	],
	"./light/ruler-triangle.svg": [
		24291,
		24291
	],
	"./light/ruler-vertical.svg": [
		61213,
		61213
	],
	"./light/ruler.svg": [
		76528,
		76528
	],
	"./light/running.svg": [
		87533,
		87533
	],
	"./light/rupee-sign.svg": [
		38734,
		38734
	],
	"./light/rv.svg": [
		26731,
		26731
	],
	"./light/sack-dollar.svg": [
		53546,
		53546
	],
	"./light/sack.svg": [
		98355,
		98355
	],
	"./light/sad-cry.svg": [
		18285,
		18285
	],
	"./light/sad-tear.svg": [
		26515,
		26515
	],
	"./light/salad.svg": [
		88061,
		88061
	],
	"./light/sandwich.svg": [
		97304,
		97304
	],
	"./light/satellite-dish.svg": [
		37934,
		37934
	],
	"./light/satellite.svg": [
		75690,
		75690
	],
	"./light/sausage.svg": [
		67620,
		67620
	],
	"./light/save.svg": [
		3861,
		3861
	],
	"./light/sax-hot.svg": [
		21405,
		21405
	],
	"./light/saxophone.svg": [
		23039,
		23039
	],
	"./light/scalpel-path.svg": [
		40365,
		40365
	],
	"./light/scalpel.svg": [
		67084,
		67084
	],
	"./light/scanner-image.svg": [
		94954,
		94954
	],
	"./light/scanner-keyboard.svg": [
		70326,
		70326
	],
	"./light/scanner-touchscreen.svg": [
		40127,
		40127
	],
	"./light/scanner.svg": [
		82775,
		82775
	],
	"./light/scarecrow.svg": [
		79217,
		79217
	],
	"./light/scarf.svg": [
		62131,
		62131
	],
	"./light/school.svg": [
		31724,
		31724
	],
	"./light/screwdriver.svg": [
		42489,
		42489
	],
	"./light/scroll-old.svg": [
		11143,
		11143
	],
	"./light/scroll.svg": [
		22514,
		22514
	],
	"./light/scrubber.svg": [
		23690,
		23690
	],
	"./light/scythe.svg": [
		21873,
		21873
	],
	"./light/sd-card.svg": [
		26558,
		26558
	],
	"./light/search-dollar.svg": [
		20060,
		20060
	],
	"./light/search-location.svg": [
		24789,
		24789
	],
	"./light/search-minus.svg": [
		48241,
		48241
	],
	"./light/search-plus.svg": [
		36157,
		36157
	],
	"./light/search.svg": [
		92781,
		92781
	],
	"./light/seedling.svg": [
		78976,
		78976
	],
	"./light/send-back.svg": [
		51424,
		51424
	],
	"./light/send-backward.svg": [
		3991,
		3991
	],
	"./light/sensor-alert.svg": [
		45883,
		45883
	],
	"./light/sensor-fire.svg": [
		41854,
		41854
	],
	"./light/sensor-on.svg": [
		57357,
		57357
	],
	"./light/sensor-smoke.svg": [
		15653,
		15653
	],
	"./light/sensor.svg": [
		97973,
		97973
	],
	"./light/server.svg": [
		72830,
		72830
	],
	"./light/shapes.svg": [
		92119,
		92119
	],
	"./light/share-all.svg": [
		69078,
		69078
	],
	"./light/share-alt-square.svg": [
		7475,
		7475
	],
	"./light/share-alt.svg": [
		64517,
		64517
	],
	"./light/share-square.svg": [
		84093,
		84093
	],
	"./light/share.svg": [
		51104,
		51104
	],
	"./light/sheep.svg": [
		5209,
		5209
	],
	"./light/shekel-sign.svg": [
		23616,
		23616
	],
	"./light/shield-alt.svg": [
		66088,
		66088
	],
	"./light/shield-check.svg": [
		27435,
		27435
	],
	"./light/shield-cross.svg": [
		21568,
		21568
	],
	"./light/shield-virus.svg": [
		62231,
		62231
	],
	"./light/shield.svg": [
		91774,
		91774
	],
	"./light/ship.svg": [
		70551,
		70551
	],
	"./light/shipping-fast.svg": [
		99778,
		99778
	],
	"./light/shipping-timed.svg": [
		51821,
		51821
	],
	"./light/shish-kebab.svg": [
		51551,
		51551
	],
	"./light/shoe-prints.svg": [
		97299,
		97299
	],
	"./light/shopping-bag.svg": [
		44626,
		44626
	],
	"./light/shopping-basket.svg": [
		379,
		379
	],
	"./light/shopping-cart.svg": [
		25978,
		72349
	],
	"./light/shovel-snow.svg": [
		98209,
		98209
	],
	"./light/shovel.svg": [
		95158,
		95158
	],
	"./light/shower.svg": [
		48320,
		48320
	],
	"./light/shredder.svg": [
		19867,
		19867
	],
	"./light/shuttle-van.svg": [
		35133,
		35133
	],
	"./light/shuttlecock.svg": [
		75299,
		75299
	],
	"./light/sickle.svg": [
		1063,
		1063
	],
	"./light/sigma.svg": [
		77832,
		77832
	],
	"./light/sign-in-alt.svg": [
		2505,
		2505
	],
	"./light/sign-in.svg": [
		27694,
		27694
	],
	"./light/sign-language.svg": [
		41013,
		41013
	],
	"./light/sign-out-alt.svg": [
		39382,
		39382
	],
	"./light/sign-out.svg": [
		1695,
		1695
	],
	"./light/sign.svg": [
		78837,
		78837
	],
	"./light/signal-1.svg": [
		32715,
		32715
	],
	"./light/signal-2.svg": [
		23046,
		23046
	],
	"./light/signal-3.svg": [
		97243,
		97243
	],
	"./light/signal-4.svg": [
		98562,
		98562
	],
	"./light/signal-alt-1.svg": [
		22204,
		22204
	],
	"./light/signal-alt-2.svg": [
		61989,
		61989
	],
	"./light/signal-alt-3.svg": [
		6700,
		6700
	],
	"./light/signal-alt-slash.svg": [
		80668,
		80668
	],
	"./light/signal-alt.svg": [
		87881,
		87881
	],
	"./light/signal-slash.svg": [
		93286,
		93286
	],
	"./light/signal-stream.svg": [
		44568,
		44568
	],
	"./light/signal.svg": [
		11036,
		11036
	],
	"./light/signature.svg": [
		41034,
		41034
	],
	"./light/sim-card.svg": [
		46577,
		46577
	],
	"./light/sink.svg": [
		5925,
		5925
	],
	"./light/siren-on.svg": [
		59920,
		59920
	],
	"./light/siren.svg": [
		97549,
		97549
	],
	"./light/sitemap.svg": [
		33775,
		33775
	],
	"./light/skating.svg": [
		13572,
		13572
	],
	"./light/skeleton.svg": [
		13801,
		13801
	],
	"./light/ski-jump.svg": [
		75200,
		75200
	],
	"./light/ski-lift.svg": [
		79151,
		94343
	],
	"./light/skiing-nordic.svg": [
		38763,
		38763
	],
	"./light/skiing.svg": [
		30087,
		30087
	],
	"./light/skull-cow.svg": [
		35568,
		35568
	],
	"./light/skull-crossbones.svg": [
		94606,
		94606
	],
	"./light/skull.svg": [
		86249,
		86249
	],
	"./light/slash.svg": [
		87460,
		87460
	],
	"./light/sledding.svg": [
		13393,
		13393
	],
	"./light/sleigh.svg": [
		74213,
		74213
	],
	"./light/sliders-h-square.svg": [
		88169,
		88169
	],
	"./light/sliders-h.svg": [
		28258,
		28258
	],
	"./light/sliders-v-square.svg": [
		64647,
		64647
	],
	"./light/sliders-v.svg": [
		67701,
		67701
	],
	"./light/smile-beam.svg": [
		49081,
		49081
	],
	"./light/smile-plus.svg": [
		40693,
		40693
	],
	"./light/smile-wink.svg": [
		82429,
		82429
	],
	"./light/smile.svg": [
		43397,
		43397
	],
	"./light/smog.svg": [
		48121,
		48121
	],
	"./light/smoke.svg": [
		66425,
		66425
	],
	"./light/smoking-ban.svg": [
		25329,
		25329
	],
	"./light/smoking.svg": [
		44462,
		44462
	],
	"./light/sms.svg": [
		50498,
		50498
	],
	"./light/snake.svg": [
		15014,
		15014
	],
	"./light/snooze.svg": [
		6701,
		6701
	],
	"./light/snow-blowing.svg": [
		84555,
		84555
	],
	"./light/snowboarding.svg": [
		63192,
		63192
	],
	"./light/snowflake.svg": [
		47088,
		82857
	],
	"./light/snowflakes.svg": [
		20170,
		20170
	],
	"./light/snowman.svg": [
		21934,
		21934
	],
	"./light/snowmobile.svg": [
		87913,
		87913
	],
	"./light/snowplow.svg": [
		91411,
		91411
	],
	"./light/soap.svg": [
		85897,
		85897
	],
	"./light/socks.svg": [
		4439,
		4439
	],
	"./light/solar-panel.svg": [
		48021,
		48021
	],
	"./light/solar-system.svg": [
		96626,
		96626
	],
	"./light/sort-alpha-down-alt.svg": [
		70321,
		70321
	],
	"./light/sort-alpha-down.svg": [
		94476,
		94476
	],
	"./light/sort-alpha-up-alt.svg": [
		32352,
		32352
	],
	"./light/sort-alpha-up.svg": [
		55694,
		55694
	],
	"./light/sort-alt.svg": [
		78186,
		78186
	],
	"./light/sort-amount-down-alt.svg": [
		18166,
		18166
	],
	"./light/sort-amount-down.svg": [
		47759,
		47759
	],
	"./light/sort-amount-up-alt.svg": [
		58494,
		58494
	],
	"./light/sort-amount-up.svg": [
		25371,
		25371
	],
	"./light/sort-circle-down.svg": [
		84753,
		84753
	],
	"./light/sort-circle-up.svg": [
		21863,
		21863
	],
	"./light/sort-circle.svg": [
		90513,
		90513
	],
	"./light/sort-down.svg": [
		74108,
		74108
	],
	"./light/sort-numeric-down-alt.svg": [
		76503,
		76503
	],
	"./light/sort-numeric-down.svg": [
		43389,
		43389
	],
	"./light/sort-numeric-up-alt.svg": [
		75208,
		75208
	],
	"./light/sort-numeric-up.svg": [
		4376,
		4376
	],
	"./light/sort-shapes-down-alt.svg": [
		49879,
		49879
	],
	"./light/sort-shapes-down.svg": [
		57066,
		57066
	],
	"./light/sort-shapes-up-alt.svg": [
		24609,
		24609
	],
	"./light/sort-shapes-up.svg": [
		22312,
		22312
	],
	"./light/sort-size-down-alt.svg": [
		36274,
		36274
	],
	"./light/sort-size-down.svg": [
		94965,
		94965
	],
	"./light/sort-size-up-alt.svg": [
		96485,
		96485
	],
	"./light/sort-size-up.svg": [
		73825,
		73825
	],
	"./light/sort-up.svg": [
		15086,
		15086
	],
	"./light/sort.svg": [
		79025,
		79025
	],
	"./light/soup.svg": [
		1110,
		1110
	],
	"./light/spa.svg": [
		8906,
		8906
	],
	"./light/space-shuttle.svg": [
		77140,
		77140
	],
	"./light/space-station-moon-alt.svg": [
		73158,
		73158
	],
	"./light/space-station-moon.svg": [
		76952,
		76952
	],
	"./light/spade.svg": [
		24784,
		24784
	],
	"./light/sparkles.svg": [
		34389,
		34389
	],
	"./light/speaker.svg": [
		61437,
		61437
	],
	"./light/speakers.svg": [
		81612,
		81612
	],
	"./light/spell-check.svg": [
		62532,
		62532
	],
	"./light/spider-black-widow.svg": [
		95563,
		95563
	],
	"./light/spider-web.svg": [
		61970,
		61970
	],
	"./light/spider.svg": [
		36054,
		36054
	],
	"./light/spinner-third.svg": [
		38952,
		38952
	],
	"./light/spinner.svg": [
		49127,
		49127
	],
	"./light/splotch.svg": [
		22555,
		22555
	],
	"./light/spray-can.svg": [
		14395,
		14395
	],
	"./light/sprinkler.svg": [
		38093,
		38093
	],
	"./light/square-full.svg": [
		17781,
		17781
	],
	"./light/square-root-alt.svg": [
		20164,
		20164
	],
	"./light/square-root.svg": [
		94097,
		94097
	],
	"./light/square.svg": [
		10873,
		10873
	],
	"./light/squirrel.svg": [
		12468,
		12468
	],
	"./light/staff.svg": [
		6313,
		6313
	],
	"./light/stamp.svg": [
		94255,
		94255
	],
	"./light/star-and-crescent.svg": [
		93987,
		93987
	],
	"./light/star-christmas.svg": [
		66143,
		66143
	],
	"./light/star-exclamation.svg": [
		56958,
		56958
	],
	"./light/star-half-alt.svg": [
		45139,
		45139
	],
	"./light/star-half.svg": [
		11442,
		11442
	],
	"./light/star-of-david.svg": [
		98927,
		98927
	],
	"./light/star-of-life.svg": [
		45721,
		45721
	],
	"./light/star-shooting.svg": [
		5511,
		5511
	],
	"./light/star.svg": [
		6231,
		6231
	],
	"./light/starfighter-alt.svg": [
		13126,
		13126
	],
	"./light/starfighter.svg": [
		88829,
		88829
	],
	"./light/stars.svg": [
		46272,
		46272
	],
	"./light/starship-freighter.svg": [
		5544,
		5544
	],
	"./light/starship.svg": [
		79454,
		79454
	],
	"./light/steak.svg": [
		67698,
		67698
	],
	"./light/steering-wheel.svg": [
		32899,
		32899
	],
	"./light/step-backward.svg": [
		82008,
		82008
	],
	"./light/step-forward.svg": [
		89262,
		89262
	],
	"./light/stethoscope.svg": [
		7018,
		7018
	],
	"./light/sticky-note.svg": [
		23744,
		23744
	],
	"./light/stocking.svg": [
		27762,
		27762
	],
	"./light/stomach.svg": [
		23002,
		23002
	],
	"./light/stop-circle.svg": [
		12096,
		12096
	],
	"./light/stop.svg": [
		25532,
		25532
	],
	"./light/stopwatch-20.svg": [
		27251,
		27251
	],
	"./light/stopwatch.svg": [
		53929,
		53929
	],
	"./light/store-alt-slash.svg": [
		44101,
		44101
	],
	"./light/store-alt.svg": [
		37164,
		37164
	],
	"./light/store-slash.svg": [
		38719,
		38719
	],
	"./light/store.svg": [
		71128,
		71128
	],
	"./light/stream.svg": [
		52477,
		52477
	],
	"./light/street-view.svg": [
		1128,
		1128
	],
	"./light/stretcher.svg": [
		97002,
		97002
	],
	"./light/strikethrough.svg": [
		98091,
		98091
	],
	"./light/stroopwafel.svg": [
		22131,
		22131
	],
	"./light/subscript.svg": [
		50888,
		50888
	],
	"./light/subway.svg": [
		21653,
		21653
	],
	"./light/suitcase-rolling.svg": [
		79412,
		79412
	],
	"./light/suitcase.svg": [
		1250,
		1250
	],
	"./light/sun-cloud.svg": [
		4206,
		4206
	],
	"./light/sun-dust.svg": [
		45549,
		45549
	],
	"./light/sun-haze.svg": [
		58970,
		58970
	],
	"./light/sun.svg": [
		1577,
		1577
	],
	"./light/sunglasses.svg": [
		21810,
		21810
	],
	"./light/sunrise.svg": [
		3891,
		3891
	],
	"./light/sunset.svg": [
		57660,
		57660
	],
	"./light/superscript.svg": [
		45855,
		45855
	],
	"./light/surprise.svg": [
		18,
		18
	],
	"./light/swatchbook.svg": [
		99451,
		99451
	],
	"./light/swimmer.svg": [
		56022,
		56022
	],
	"./light/swimming-pool.svg": [
		80239,
		80239
	],
	"./light/sword-laser-alt.svg": [
		62529,
		62529
	],
	"./light/sword-laser.svg": [
		53331,
		53331
	],
	"./light/sword.svg": [
		84697,
		84697
	],
	"./light/swords-laser.svg": [
		4826,
		4826
	],
	"./light/swords.svg": [
		20805,
		20805
	],
	"./light/synagogue.svg": [
		28169,
		28169
	],
	"./light/sync-alt.svg": [
		90525,
		90525
	],
	"./light/sync.svg": [
		71324,
		71324
	],
	"./light/syringe.svg": [
		10869,
		10869
	],
	"./light/table-tennis.svg": [
		64678,
		64678
	],
	"./light/table.svg": [
		59633,
		59633
	],
	"./light/tablet-alt.svg": [
		14579,
		14579
	],
	"./light/tablet-android-alt.svg": [
		72152,
		72152
	],
	"./light/tablet-android.svg": [
		80790,
		80790
	],
	"./light/tablet-rugged.svg": [
		55100,
		55100
	],
	"./light/tablet.svg": [
		33700,
		33700
	],
	"./light/tablets.svg": [
		60901,
		60901
	],
	"./light/tachometer-alt-average.svg": [
		22326,
		22326
	],
	"./light/tachometer-alt-fast.svg": [
		6391,
		6391
	],
	"./light/tachometer-alt-fastest.svg": [
		81513,
		81513
	],
	"./light/tachometer-alt-slow.svg": [
		81280,
		81280
	],
	"./light/tachometer-alt-slowest.svg": [
		61655,
		61655
	],
	"./light/tachometer-alt.svg": [
		59705,
		59705
	],
	"./light/tachometer-average.svg": [
		38151,
		38151
	],
	"./light/tachometer-fast.svg": [
		83705,
		83705
	],
	"./light/tachometer-fastest.svg": [
		43270,
		43270
	],
	"./light/tachometer-slow.svg": [
		86716,
		86716
	],
	"./light/tachometer-slowest.svg": [
		75272,
		75272
	],
	"./light/tachometer.svg": [
		78987,
		78987
	],
	"./light/taco.svg": [
		77644,
		77644
	],
	"./light/tag.svg": [
		55518,
		55518
	],
	"./light/tags.svg": [
		35300,
		35300
	],
	"./light/tally.svg": [
		66167,
		77044
	],
	"./light/tanakh.svg": [
		30644,
		30644
	],
	"./light/tape.svg": [
		78329,
		78329
	],
	"./light/tasks-alt.svg": [
		38461,
		38461
	],
	"./light/tasks.svg": [
		25813,
		25813
	],
	"./light/taxi.svg": [
		77065,
		77065
	],
	"./light/teeth-open.svg": [
		22512,
		22512
	],
	"./light/teeth.svg": [
		5446,
		5446
	],
	"./light/telescope.svg": [
		15351,
		15351
	],
	"./light/temperature-down.svg": [
		50345,
		50345
	],
	"./light/temperature-frigid.svg": [
		82533,
		82533
	],
	"./light/temperature-high.svg": [
		58057,
		58057
	],
	"./light/temperature-hot.svg": [
		7791,
		7791
	],
	"./light/temperature-low.svg": [
		24253,
		24253
	],
	"./light/temperature-up.svg": [
		43133,
		43133
	],
	"./light/tenge.svg": [
		51529,
		51529
	],
	"./light/tennis-ball.svg": [
		64954,
		64954
	],
	"./light/terminal.svg": [
		35428,
		35428
	],
	"./light/text-height.svg": [
		2435,
		2435
	],
	"./light/text-size.svg": [
		50889,
		50889
	],
	"./light/text-width.svg": [
		12260,
		12260
	],
	"./light/text.svg": [
		30494,
		30494
	],
	"./light/th-large.svg": [
		42518,
		42518
	],
	"./light/th-list.svg": [
		11380,
		11380
	],
	"./light/th.svg": [
		97818,
		97818
	],
	"./light/theater-masks.svg": [
		81132,
		81132
	],
	"./light/thermometer-empty.svg": [
		51445,
		51445
	],
	"./light/thermometer-full.svg": [
		27385,
		27385
	],
	"./light/thermometer-half.svg": [
		19471,
		19471
	],
	"./light/thermometer-quarter.svg": [
		69427,
		69427
	],
	"./light/thermometer-three-quarters.svg": [
		44546,
		44546
	],
	"./light/thermometer.svg": [
		23176,
		23176
	],
	"./light/theta.svg": [
		25857,
		25857
	],
	"./light/thumbs-down.svg": [
		96977,
		96977
	],
	"./light/thumbs-up.svg": [
		78400,
		78400
	],
	"./light/thumbtack.svg": [
		31115,
		31115
	],
	"./light/thunderstorm-moon.svg": [
		90572,
		90572
	],
	"./light/thunderstorm-sun.svg": [
		991,
		991
	],
	"./light/thunderstorm.svg": [
		6732,
		6732
	],
	"./light/ticket-alt.svg": [
		79041,
		79041
	],
	"./light/ticket.svg": [
		63007,
		63007
	],
	"./light/tilde.svg": [
		78571,
		78571
	],
	"./light/times-circle.svg": [
		84648,
		84648
	],
	"./light/times-hexagon.svg": [
		56229,
		56229
	],
	"./light/times-octagon.svg": [
		45639,
		45639
	],
	"./light/times-square.svg": [
		35902,
		35902
	],
	"./light/times.svg": [
		54451,
		54451
	],
	"./light/tint-slash.svg": [
		74436,
		74436
	],
	"./light/tint.svg": [
		98476,
		98476
	],
	"./light/tire-flat.svg": [
		96314,
		96314
	],
	"./light/tire-pressure-warning.svg": [
		26064,
		26064
	],
	"./light/tire-rugged.svg": [
		96114,
		96114
	],
	"./light/tire.svg": [
		80761,
		80761
	],
	"./light/tired.svg": [
		60594,
		60594
	],
	"./light/toggle-off.svg": [
		64380,
		64380
	],
	"./light/toggle-on.svg": [
		66515,
		66515
	],
	"./light/toilet-paper-alt.svg": [
		14644,
		14644
	],
	"./light/toilet-paper-slash.svg": [
		97327,
		97327
	],
	"./light/toilet-paper.svg": [
		97600,
		97600
	],
	"./light/toilet.svg": [
		35354,
		35354
	],
	"./light/tombstone-alt.svg": [
		80179,
		80179
	],
	"./light/tombstone.svg": [
		58035,
		58035
	],
	"./light/toolbox.svg": [
		1148,
		1148
	],
	"./light/tools.svg": [
		74101,
		74101
	],
	"./light/tooth.svg": [
		56153,
		56153
	],
	"./light/toothbrush.svg": [
		92723,
		92723
	],
	"./light/torah.svg": [
		97668,
		97668
	],
	"./light/torii-gate.svg": [
		54901,
		54901
	],
	"./light/tornado.svg": [
		37278,
		37278
	],
	"./light/tractor.svg": [
		26016,
		26016
	],
	"./light/trademark.svg": [
		8927,
		8927
	],
	"./light/traffic-cone.svg": [
		36233,
		36233
	],
	"./light/traffic-light-go.svg": [
		55578,
		55578
	],
	"./light/traffic-light-slow.svg": [
		24188,
		24188
	],
	"./light/traffic-light-stop.svg": [
		68920,
		68920
	],
	"./light/traffic-light.svg": [
		26123,
		26123
	],
	"./light/trailer.svg": [
		50439,
		50439
	],
	"./light/train.svg": [
		29731,
		29731
	],
	"./light/tram.svg": [
		67006,
		67006
	],
	"./light/transgender-alt.svg": [
		60578,
		60578
	],
	"./light/transgender.svg": [
		2762,
		2762
	],
	"./light/transporter-1.svg": [
		92892,
		92892
	],
	"./light/transporter-2.svg": [
		76060,
		76060
	],
	"./light/transporter-3.svg": [
		45690,
		45690
	],
	"./light/transporter-empty.svg": [
		83025,
		83025
	],
	"./light/transporter.svg": [
		29066,
		29066
	],
	"./light/trash-alt.svg": [
		93984,
		93984
	],
	"./light/trash-restore-alt.svg": [
		54369,
		54369
	],
	"./light/trash-restore.svg": [
		95235,
		95235
	],
	"./light/trash-undo-alt.svg": [
		20818,
		20818
	],
	"./light/trash-undo.svg": [
		32924,
		32924
	],
	"./light/trash.svg": [
		81646,
		81646
	],
	"./light/treasure-chest.svg": [
		17379,
		17379
	],
	"./light/tree-alt.svg": [
		18362,
		18362
	],
	"./light/tree-christmas.svg": [
		2657,
		2657
	],
	"./light/tree-decorated.svg": [
		45358,
		45358
	],
	"./light/tree-large.svg": [
		9241,
		9241
	],
	"./light/tree-palm.svg": [
		4428,
		4428
	],
	"./light/tree.svg": [
		3844,
		3844
	],
	"./light/trees.svg": [
		24755,
		24755
	],
	"./light/triangle-music.svg": [
		63824,
		63824
	],
	"./light/triangle.svg": [
		96009,
		96009
	],
	"./light/trophy-alt.svg": [
		52128,
		52128
	],
	"./light/trophy.svg": [
		30056,
		30056
	],
	"./light/truck-container.svg": [
		54831,
		54831
	],
	"./light/truck-couch.svg": [
		2387,
		2387
	],
	"./light/truck-loading.svg": [
		58619,
		58619
	],
	"./light/truck-monster.svg": [
		56748,
		56748
	],
	"./light/truck-moving.svg": [
		75721,
		75721
	],
	"./light/truck-pickup.svg": [
		7448,
		7448
	],
	"./light/truck-plow.svg": [
		92438,
		92438
	],
	"./light/truck-ramp.svg": [
		24396,
		24396
	],
	"./light/truck.svg": [
		42005,
		42005
	],
	"./light/trumpet.svg": [
		9730,
		9730
	],
	"./light/tshirt.svg": [
		83768,
		83768
	],
	"./light/tty.svg": [
		88889,
		88889
	],
	"./light/turkey.svg": [
		81249,
		81249
	],
	"./light/turntable.svg": [
		7382,
		7382
	],
	"./light/turtle.svg": [
		1515,
		1515
	],
	"./light/tv-alt.svg": [
		91034,
		91034
	],
	"./light/tv-music.svg": [
		586,
		586
	],
	"./light/tv-retro.svg": [
		85189,
		85189
	],
	"./light/tv.svg": [
		98955,
		98955
	],
	"./light/typewriter.svg": [
		25645,
		25645
	],
	"./light/ufo-beam.svg": [
		56417,
		56417
	],
	"./light/ufo.svg": [
		22246,
		22246
	],
	"./light/umbrella-beach.svg": [
		85745,
		85745
	],
	"./light/umbrella.svg": [
		33470,
		33470
	],
	"./light/underline.svg": [
		58460,
		58460
	],
	"./light/undo-alt.svg": [
		63742,
		63742
	],
	"./light/undo.svg": [
		85944,
		85944
	],
	"./light/unicorn.svg": [
		13058,
		13058
	],
	"./light/union.svg": [
		86796,
		86796
	],
	"./light/universal-access.svg": [
		72949,
		72949
	],
	"./light/university.svg": [
		771,
		771
	],
	"./light/unlink.svg": [
		52198,
		52198
	],
	"./light/unlock-alt.svg": [
		96730,
		96730
	],
	"./light/unlock.svg": [
		28079,
		28079
	],
	"./light/upload.svg": [
		58132,
		58132
	],
	"./light/usb-drive.svg": [
		33282,
		33282
	],
	"./light/usd-circle.svg": [
		43136,
		43136
	],
	"./light/usd-square.svg": [
		67841,
		67841
	],
	"./light/user-alien.svg": [
		41386,
		41386
	],
	"./light/user-alt-slash.svg": [
		12128,
		12128
	],
	"./light/user-alt.svg": [
		32459,
		32459
	],
	"./light/user-astronaut.svg": [
		34702,
		34702
	],
	"./light/user-chart.svg": [
		37059,
		37059
	],
	"./light/user-check.svg": [
		34021,
		34021
	],
	"./light/user-circle.svg": [
		32954,
		32954
	],
	"./light/user-clock.svg": [
		25962,
		25962
	],
	"./light/user-cog.svg": [
		88240,
		88240
	],
	"./light/user-cowboy.svg": [
		91074,
		91074
	],
	"./light/user-crown.svg": [
		57662,
		57662
	],
	"./light/user-edit.svg": [
		10309,
		10309
	],
	"./light/user-friends.svg": [
		64255,
		64255
	],
	"./light/user-graduate.svg": [
		89337,
		89337
	],
	"./light/user-hard-hat.svg": [
		37264,
		37264
	],
	"./light/user-headset.svg": [
		46298,
		46298
	],
	"./light/user-injured.svg": [
		37341,
		37341
	],
	"./light/user-lock.svg": [
		95040,
		95040
	],
	"./light/user-md-chat.svg": [
		22102,
		22102
	],
	"./light/user-md.svg": [
		48985,
		48985
	],
	"./light/user-minus.svg": [
		18866,
		18866
	],
	"./light/user-music.svg": [
		91181,
		91181
	],
	"./light/user-ninja.svg": [
		44557,
		44557
	],
	"./light/user-nurse.svg": [
		79521,
		79521
	],
	"./light/user-plus.svg": [
		88012,
		88012
	],
	"./light/user-robot.svg": [
		37741,
		37741
	],
	"./light/user-secret.svg": [
		15709,
		15709
	],
	"./light/user-shield.svg": [
		48496,
		48496
	],
	"./light/user-slash.svg": [
		41804,
		41804
	],
	"./light/user-tag.svg": [
		18125,
		18125
	],
	"./light/user-tie.svg": [
		39982,
		39982
	],
	"./light/user-times.svg": [
		91872,
		91872
	],
	"./light/user-unlock.svg": [
		27845,
		27845
	],
	"./light/user-visor.svg": [
		29889,
		29889
	],
	"./light/user.svg": [
		96369,
		96369
	],
	"./light/users-class.svg": [
		86824,
		86824
	],
	"./light/users-cog.svg": [
		7337,
		7337
	],
	"./light/users-crown.svg": [
		88276,
		88276
	],
	"./light/users-medical.svg": [
		96860,
		96860
	],
	"./light/users-slash.svg": [
		87646,
		87646
	],
	"./light/users.svg": [
		44468,
		44468
	],
	"./light/utensil-fork.svg": [
		10077,
		10077
	],
	"./light/utensil-knife.svg": [
		53100,
		53100
	],
	"./light/utensil-spoon.svg": [
		27105,
		27105
	],
	"./light/utensils-alt.svg": [
		69374,
		69374
	],
	"./light/utensils.svg": [
		60833,
		60833
	],
	"./light/vacuum-robot.svg": [
		19788,
		19788
	],
	"./light/vacuum.svg": [
		90073,
		90073
	],
	"./light/value-absolute.svg": [
		86738,
		86738
	],
	"./light/vector-square.svg": [
		19324,
		19324
	],
	"./light/venus-double.svg": [
		55473,
		55473
	],
	"./light/venus-mars.svg": [
		10390,
		10390
	],
	"./light/venus.svg": [
		76654,
		76654
	],
	"./light/vhs.svg": [
		92807,
		92807
	],
	"./light/vial.svg": [
		33794,
		89693
	],
	"./light/vials.svg": [
		52622,
		52622
	],
	"./light/video-plus.svg": [
		95220,
		95220
	],
	"./light/video-slash.svg": [
		26936,
		26936
	],
	"./light/video.svg": [
		23331,
		23331
	],
	"./light/vihara.svg": [
		34051,
		34051
	],
	"./light/violin.svg": [
		20254,
		20254
	],
	"./light/virus-slash.svg": [
		26187,
		26187
	],
	"./light/virus.svg": [
		94565,
		94565
	],
	"./light/viruses.svg": [
		83061,
		83061
	],
	"./light/voicemail.svg": [
		11783,
		11783
	],
	"./light/volcano.svg": [
		72176,
		72176
	],
	"./light/volleyball-ball.svg": [
		99926,
		99926
	],
	"./light/volume-down.svg": [
		34801,
		34801
	],
	"./light/volume-mute.svg": [
		43377,
		43377
	],
	"./light/volume-off.svg": [
		36104,
		36104
	],
	"./light/volume-slash.svg": [
		99540,
		99540
	],
	"./light/volume-up.svg": [
		73877,
		73877
	],
	"./light/volume.svg": [
		40653,
		40653
	],
	"./light/vote-nay.svg": [
		8135,
		8135
	],
	"./light/vote-yea.svg": [
		4616,
		4616
	],
	"./light/vr-cardboard.svg": [
		54456,
		54456
	],
	"./light/wagon-covered.svg": [
		86870,
		86870
	],
	"./light/walker.svg": [
		89296,
		89296
	],
	"./light/walkie-talkie.svg": [
		32356,
		32356
	],
	"./light/walking.svg": [
		59517,
		59517
	],
	"./light/wallet.svg": [
		49282,
		49282
	],
	"./light/wand-magic.svg": [
		17749,
		17749
	],
	"./light/wand.svg": [
		58732,
		58732
	],
	"./light/warehouse-alt.svg": [
		20144,
		20144
	],
	"./light/warehouse.svg": [
		24516,
		24516
	],
	"./light/washer.svg": [
		92174,
		92174
	],
	"./light/watch-calculator.svg": [
		94795,
		94795
	],
	"./light/watch-fitness.svg": [
		95743,
		95743
	],
	"./light/watch.svg": [
		88822,
		88822
	],
	"./light/water-lower.svg": [
		43998,
		43998
	],
	"./light/water-rise.svg": [
		97495,
		97495
	],
	"./light/water.svg": [
		86840,
		86840
	],
	"./light/wave-sine.svg": [
		86376,
		86376
	],
	"./light/wave-square.svg": [
		85691,
		85691
	],
	"./light/wave-triangle.svg": [
		75671,
		75671
	],
	"./light/waveform-path.svg": [
		44353,
		44353
	],
	"./light/waveform.svg": [
		3642,
		3642
	],
	"./light/webcam-slash.svg": [
		6310,
		6310
	],
	"./light/webcam.svg": [
		60559,
		60559
	],
	"./light/weight-hanging.svg": [
		81768,
		81768
	],
	"./light/weight.svg": [
		39711,
		39711
	],
	"./light/whale.svg": [
		69864,
		69864
	],
	"./light/wheat.svg": [
		48766,
		48766
	],
	"./light/wheelchair.svg": [
		946,
		946
	],
	"./light/whistle.svg": [
		61400,
		61400
	],
	"./light/wifi-1.svg": [
		55021,
		55021
	],
	"./light/wifi-2.svg": [
		71791,
		71791
	],
	"./light/wifi-slash.svg": [
		8581,
		8581
	],
	"./light/wifi.svg": [
		5158,
		5158
	],
	"./light/wind-turbine.svg": [
		82381,
		82381
	],
	"./light/wind-warning.svg": [
		30610,
		30610
	],
	"./light/wind.svg": [
		77570,
		77570
	],
	"./light/window-alt.svg": [
		1540,
		1540
	],
	"./light/window-close.svg": [
		79635,
		79635
	],
	"./light/window-frame-open.svg": [
		44427,
		44427
	],
	"./light/window-frame.svg": [
		83180,
		83180
	],
	"./light/window-maximize.svg": [
		46930,
		46930
	],
	"./light/window-minimize.svg": [
		91244,
		91244
	],
	"./light/window-restore.svg": [
		75544,
		75544
	],
	"./light/window.svg": [
		37645,
		37645
	],
	"./light/windsock.svg": [
		49478,
		49478
	],
	"./light/wine-bottle.svg": [
		61536,
		61536
	],
	"./light/wine-glass-alt.svg": [
		35967,
		35967
	],
	"./light/wine-glass.svg": [
		52582,
		52582
	],
	"./light/won-sign.svg": [
		26843,
		26843
	],
	"./light/wreath.svg": [
		87833,
		87833
	],
	"./light/wrench.svg": [
		73028,
		73028
	],
	"./light/x-ray.svg": [
		32447,
		32447
	],
	"./light/yen-sign.svg": [
		67552,
		67552
	],
	"./light/yin-yang.svg": [
		10037,
		10037
	],
	"./logos/buyingJourney.svg": [
		89620,
		89620
	],
	"./logos/compliance.svg": [
		98167,
		98167
	],
	"./logos/contentDiscoverty.svg": [
		89796,
		89796
	],
	"./logos/createIconTube.svg": [
		91978,
		91978
	],
	"./logos/customerSupport.svg": [
		62701,
		62701
	],
	"./logos/groupPeopleTube.svg": [
		95737,
		95737
	],
	"./logos/hostKpoint.svg": [
		11136,
		11136
	],
	"./logos/knowledgeRetention.svg": [
		48923,
		48923
	],
	"./logos/learningPaths.svg": [
		88301,
		88301
	],
	"./logos/miniXpressoLogo.svg": [
		12617,
		12617
	],
	"./logos/onBoarding.svg": [
		27393,
		27393
	],
	"./logos/onboardingDigital.svg": [
		10745,
		10745
	],
	"./logos/organiseIcon.svg": [
		51238,
		51238
	],
	"./logos/personalize.svg": [
		97249,
		97249
	],
	"./logos/preOnBoardingtube.svg": [
		9513,
		9513
	],
	"./logos/shareIcon.svg": [
		12796,
		12796
	],
	"./logos/teamColabration.svg": [
		59359,
		59359
	],
	"./logos/tubeLogo.svg": [
		22467,
		22467
	],
	"./logos/xpressoLogo.svg": [
		64272,
		64272
	],
	"./logos/xpressoTextLogo.svg": [
		91172,
		91172
	],
	"./play/analytics.svg": [
		79470,
		79470
	],
	"./play/customerSupport.svg": [
		6421,
		6421
	],
	"./play/diyInteractivityBuilder.svg": [
		79856,
		79856
	],
	"./play/outcomeDrivenInteractivity.svg": [
		90381,
		90381
	],
	"./play/playLogo.svg": [
		42590,
		42590
	],
	"./play/publishVideosDirectly.svg": [
		75923,
		75923
	],
	"./play/upsellCrosssell.svg": [
		86960,
		86960
	],
	"./regular/file-lines.svg": [
		27108,
		27108
	],
	"./regular/file-magnifying-glass.svg": [
		84831,
		84831
	],
	"./regular/film.svg": [
		73408,
		73408
	],
	"./regular/globe.svg": [
		57762,
		57762
	],
	"./regular/magnifying-glass.svg": [
		47422,
		47422
	],
	"./solid/caret-down.svg": [
		34015,
		34015
	],
	"./solid/envelope.svg": [
		66768,
		66768
	],
	"./solid/info-circle.svg": [
		58855,
		58855
	],
	"./solid/play.svg": [
		87373,
		87373
	],
	"./tube/anyDevice.svg": [
		11968,
		11968
	],
	"./tube/everyVideoDetailedData.svg": [
		8749,
		8749
	],
	"./tube/yourdataYourControl.svg": [
		53198,
		53198
	],
	"./xpresso/collaborateAndPublish.svg": [
		13404,
		13404
	],
	"./xpresso/communication.svg": [
		54789,
		54789
	],
	"./xpresso/digitalCommunities.svg": [
		18756,
		18756
	],
	"./xpresso/easyEdit.svg": [
		94091,
		94091
	],
	"./xpresso/employeeDevelopment.svg": [
		49634,
		49634
	],
	"./xpresso/fieldForceConnect.svg": [
		33599,
		33599
	],
	"./xpresso/knowledge.svg": [
		86917,
		86917
	],
	"./xpresso/personalizedContentDiscovery.svg": [
		24328,
		24328
	],
	"./xpresso/techAdoption.svg": [
		25942,
		25942
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40531;
module.exports = webpackAsyncContext;